/* eslint-disable no-template-curly-in-string */
export const translations = {
  en: {
    aboutUs: "About Us",
    categories: "Categories",
    contactUs: "Contact Us",
    products: "Products",
    newArrival: "New Arrival",
    searchPlaceholder: "Search the store",
    needHelp: "Need help? Call us:",
    signIn: "Sign In",
    signOut: "Sign Out",
    cart: "Cart",
    expressDelivery: "Express Delivery in 2 to 3 Working Days",
    callOrWhatsapp: "Call or WhatsApp",
    browseByCategory: "Browse By Category",
    categoriesHeading: "CATEGORIES",
    exploreOurProducts: "Explore Our Products",
    ourProductsHeading: "OUR PRODUCTS",
    addToCart: "Add to Cart",
    buyNow: "Buy Now",
    noProductsFound: "No Products Found",
    inStock: "In Stock",
    outOfStock: "Out Of Stock",
    reviews: "Reviews",
    freeShipping: "Free Shipping",
    freeShippingDesc: "For orders over €150 or flat delivery",
    securePayment: "Secure Payment",
    securePaymentDesc: "100% secure payment methods",
    helpCenter: "24/7 Help Center",
    helpCenterDesc: "Contact us anytime for customer support",
    easyReturns: "Easy Returns",
    easyReturnsDesc: "Hassle-free return policy within 14 days",
    shoppingCart: "Shopping Cart",
    itemsInCart: "items in your cart",
    itemInCart: "item in your cart",
    emptyCartTitle: "Your Cart is Empty",
    emptyCartDesc: "Looks like you haven't added any products to your cart yet. Explore our store for premium devices and accessories.",
    continueShopping: "Continue Shopping",
    price: "Price",
    quantity: "Quantity",
    total: "Total",
    removeConfirmTitle: "Remove Item?",
    removeConfirmText: "Are you sure you want to remove this item from the cart?",
    yesRemove: "Yes, remove it!",
    removedSuccess: "Removed!",
    removedText: "Item has been removed.",
    subtotal: "Subtotal",
    shipping: "Shipping",
    free: "FREE",
    grandTotal: "Grand Total",
    proceedToCheckout: "Proceed to Checkout",
    sslSecureCheckout: "SSL SECURE CHECKOUT",
    shippingAlert: "Add ${amount} more to get free shipping!",
    vatIncluded: "Est. BTW/VAT (21%)",
    checkout: "Checkout",
    backToCart: "Back to Cart",
    stepShipping: "Shipping",
    stepPayment: "Payment",
    stepReview: "Review",
    contactInfo: "Contact Information",
    emailAddress: "Email address",
    shippingAddress: "Shipping Address",
    fullName: "Full Name",
    addressLine1: "Address Line 1",
    addressLine2: "Address Line 2 (Optional)",
    city: "City",
    stateProvince: "State / Province",
    zipPostalCode: "ZIP / Postal Code",
    country: "Country",
    saveInformation: "Save this information for next time",
    shippingMethod: "Shipping Method",
    pickupFromStore: "Pickup from store",
    shippingOnDelivery: "Shipping on delivery",
    warrantyPolicy: "Warranty Policy",
    orderSummary: "Order Summary",
    continueToPayment: "Continue to Payment",
    missingInfoTitle: "Missing Information",
    missingInfoText: "Please fill out all required fields to proceed.",
    paymentCompletedTitle: "Payment Completed!",
    paymentCompletedText: "Thank you for your purchase. We are redirecting you to your receipt...",
    checkoutFailedTitle: "Checkout Failed",
    connectionErrorTitle: "Connection Error",
    connectionErrorText: "Failed to connect to the backend server.",
    thankYou: "Thank You!",
    orderSuccessDesc: "Your order has been placed successfully and payment is confirmed.",
    orderId: "Order ID",
    customerName: "Customer Name",
    totalAmount: "Total Amount",
    receiptNotice: "A receipt PDF file receipt_{id}.pdf has been automatically generated and downloaded to your downloads folder.",
    noActiveOrderTitle: "No Active Order",
    noActiveOrderDesc: "We couldn't find any recent checkout transaction details. Please visit our homepage to shop products.",
    goToHomepage: "Go to Homepage",
    relatedProducts: "Related Products",
    returnToStore: "Return to Store",
    productNotFound: "Product Not Found",
    getInTouch: "Get In Touch",
    contactDesc: "We would love to hear from you. Please fill out the form below.",
    message: "Message",
    sendMessage: "Send Message",
    aboutTitle: "About Our Store",
    aboutDesc: "We provide high-quality mobile phones and premium electronic accessories to our customers worldwide.",
    contact: "Contact",
    information: "Information",
    faq: "FAQ",
    privacyPolicy: "Privacy Policy",
    termsOfService: "Terms of Service",
    newsletter: "Newsletter",
    subscribeDesc: "Subscribe to receive updates, access to exclusive deals, and more.",
    subscribe: "Subscribe",
    allRightsReserved: "All rights reserved",
    newAudioCollection: "New Audio Collection",
    premiumOverEarHeadphones: "PREMIUM OVER-EAR HEADPHONES",
    featureToday: "Feature Today",
    todaySpecialPrice: "Today Special Price",
    xiaomiRedmiNote13: "XIAOMI REDMI NOTE 13 (5G)",
    shopNow: "Shop now",
    smartWearables: "Smart Wearables",
    trendingSmartwatches: "TRENDING SMARTWATCHES",
    deliveryTitle: "FREE AND FAST DELIVERY",
    deliveryDesc: "Free delivery for all orders over €140",
    customerServiceTitle: "24/7 CUSTOMER SERVICE",
    customerServiceDesc: "Friendly 24/7 customer support",
    guaranteeTitle: "MONEY BACK GUARANTEE",
    guaranteeDesc: "We return money within 30 days"
  ,
    home: "Home",
    unitPrice: "Unit Price",
    qtyLabel: "Qty",
    dateLabel: "Date",
    paymentLabel: "Payment",
    paidConfirmed: "PAID / CONFIRMED",
    invoiceReceipt: "INVOICE / RECEIPT",
    descriptionAndSpecs: "Description & Specifications",
    shippingAndWarranty: "Shipping & Warranty",
    discountLabel: "Discount",
    promoDiscount: "Promo 10% Off",
    packageLabel: "Package",
    packageDesc: "Retail Sealed Box",
    deliveryTimeLabel: "Delivery Time",
    deliveryTimeDesc: "1-2 Working Days",
    warrantyLabel: "Warranty",
    warrantyDesc: "6 Months Store Warranty",
    thankYouShopping: "Thank you for shopping with Smart Telecom Store!",
    productDescription: "Product Description",
    footerQuestions: "Got Questions ? Call us 24/7!",
    usefulLinks: "Useful Links",
    featuredGallery: "Featured Gallery",
    brands: "Brands",
    categoryMobilePhone: "Mobile Phone",
    categoryAccessories: "Accessories",
    categoryGadget: "Gadget",
    categoryService: "Service",
    categoryParts: "Parts",
    categoryComputers: "Computers",
    categoryOffers: "Offers",
    categoryUsedPhone: "Used Phone",
    categoryElectronics: "Electronics",
    newArrivalLargeTitle: "Flagship Smart Phones",
    newArrivalLargeDesc: "Experience the ultimate performance and camera quality with our latest models.",
    newArrivalHorizontalTitle: "Premium Laptops",
    newArrivalHorizontalDesc: "Sleek, powerful ultrabooks designed for productivity and creators.",
    newArrivalSquare1Title: "Wireless Audio",
    newArrivalSquare1Desc: "High-fidelity noise cancelling audio.",
    newArrivalSquare2Title: "Smart Wearables",
    newArrivalSquare2Desc: "Stay active, track health and alerts.",
    dontHaveAccount: "Don't have an account?",
    alreadyHaveAccount: "Already have an account?",
    createAccount: "Create Account",
    agreeTerms: "I agree to the Terms & Conditions",
    rememberMe: "Remember me",
    forgotPassword: "Forgot Password?",
    createPasswordPlaceholder: "Create a password",
    passwordPlaceholder: "Enter your password",
    fullNamePlaceholder: "Enter your full name",
    emailPlaceholder: "Enter your email",
    authSubheadingLogin: "Enter your details below to access your account",
    authSubheadingRegister: "Sign up in seconds to start shopping",
    validationError: "Validation Error",
    mustAgreeTerms: "You must agree to the Terms & Conditions to proceed.",
    creatingAccount: "Creating Account...",
    pleaseWaitConnect: "Please wait while we connect to the database.",
    registrationFailed: "Registration Failed",
    accountCreatedSuccess: "Your account has been created successfully. Redirecting to login...",
    signingIn: "Signing In...",
    validatingCredentials: "Validating credentials with secure server.",
    authFailed: "Authentication Failed",
    success: "Success!",
    welcomeBack: "Welcome back, {name}! Redirecting to homepage...",
    authConnectionErrorText: "Could not connect to authentication server.",
    aboutMission: "Our Mission",
    aboutMissionDesc: "To connect people with the best technology and repair services that simplify life. We source the highest quality gadgets and provide authentic customer care.",
    aboutVision: "Our Vision",
    aboutVisionDesc: "To become the most reliable and premium destination for mobile hardware solutions and gadgets in the Netherlands and beyond.",
    aboutGuarantee: "Our Guarantee",
    aboutGuaranteeDesc: "We back our services and premium items with a comprehensive warranty and top-tier OEM parts to ensure total peace of mind.",
    aboutWhoWeAre: "WHO WE ARE",
    aboutStoryTitle: "Crafting Premium Tech Experiences Since 2018",
    aboutStoryDesc1: "Smart Telecom Store started as a small, specialized repair workshop dedicated to bringing devices back to life. Our passion for precision engineering and deep appreciation for premium gadgets quickly turned us into a trusted community anchor.",
    aboutStoryDesc2: "Today, we have grown into a comprehensive e-commerce hub, providing not just expert repair solutions but also an exclusive curated collection of smartphones, audio devices, smart wearables, and top-tier accessories.",
    aboutStatsHappy: "Happy Clients",
    aboutStatsSuccess: "Repair Success",
    aboutStatsSupport: "Online Support",
    faqPillBadge: "Frequently asked questions",
    faqTitleFirst: "Frequently asked",
    faqTitleSecond: "questions",
    faqSectionDesc: "Got questions about our services, repair process, or product warranties? We have gathered answers to some of the most common questions our clients ask.",
    faqQ1: "What services does Smart Telecom Store offer?",
    faqA1: "Smart Telecom Store offers a wide range of premium services, including smartphone and tablet sales (brand-new and certified pre-owned), high-quality repair services (screen replacement, battery diagnostics, motherboard soldering), and a curated collection of tech accessories like cases, cables, chargers, and audio gear.",
    faqQ2: "How long does a typical mobile repair take?",
    faqA2: "Most standard repairs like screen replacements, battery changes, and charging port fixes are completed within 30 to 60 minutes. You can walk in or book an appointment online. Advanced diagnostics or motherboard repairs may take 1 to 2 business days.",
    faqQ3: "Do you offer a warranty on repairs and purchases?",
    faqA3: "Absolutely! We offer a 6-month worry-free warranty on all repair services and replacement parts. Brand-new retail products carry their official manufacturer warranties.",
    faqQ4: "Can I trade in my old device at Smart Telecom Store?",
    faqA4: "Yes, you can! Bring your old phone or tablet to any of our stores. We will run a quick evaluation and offer you competitive store credit or cash that you can apply immediately to upgrade your device."
  },
  nl: {
    aboutUs: "Over Ons",
    categories: "Categorieën",
    contactUs: "Contact",
    products: "Producten",
    newArrival: "Nieuwe Collectie",
    searchPlaceholder: "Doorzoek de winkel",
    needHelp: "Hulp nodig? Bel ons:",
    signIn: "Inloggen",
    signOut: "Uitloggen",
    cart: "Winkelwagen",
    expressDelivery: "Express levering in 2 tot 3 werkdagen",
    callOrWhatsapp: "Bel of WhatsApp",
    browseByCategory: "Bladeren Per Categorie",
    categoriesHeading: "CATEGORIEËN",
    exploreOurProducts: "Ontdek Onze Producten",
    ourProductsHeading: "ONZE PRODUCTEN",
    addToCart: "In Winkelwagen",
    buyNow: "Nu Kopen",
    noProductsFound: "Geen producten gevonden",
    inStock: "Op voorraad",
    outOfStock: "Niet op voorraad",
    reviews: "Beoordelingen",
    freeShipping: "Gratis Verzending",
    freeShippingDesc: "Voor bestellingen vanaf €150 of vaste levering",
    securePayment: "Veilig Betalen",
    securePaymentDesc: "100% veilige betalingsmethoden",
    helpCenter: "24/7 Helpcentrum",
    helpCenterDesc: "Neem op elk moment contact op voor ondersteuning",
    easyReturns: "Eenvoudig Retourneren",
    easyReturnsDesc: "Probleemloos retourbeleid binnen 14 dagen",
    shoppingCart: "Winkelwagen",
    itemsInCart: "artikelen in uw winkelwagen",
    itemInCart: "artikel in uw winkelwagen",
    emptyCartTitle: "Uw Winkelwagen is Leeg",
    emptyCartDesc: "Het lijkt erop dat u nog geen producten aan uw winkelwagen heeft toegevoegd. Verken onze winkel voor premium apparaten en accessoires.",
    continueShopping: "Doorgaan met Winkelen",
    price: "Prijs",
    quantity: "Aantal",
    total: "Totaal",
    removeConfirmTitle: "Artikel Verwijderen?",
    removeConfirmText: "Weet u zeker dat u dit artikel uit de winkelwagen wilt verwijderen?",
    yesRemove: "Ja, verwijder het!",
    removedSuccess: "Verwijderd!",
    removedText: "Artikel is verwijderd.",
    subtotal: "Subtotaal",
    shipping: "Verzendkosten",
    free: "GRATIS",
    grandTotal: "Totaalprijs",
    proceedToCheckout: "Doorgaan naar Afrekenen",
    sslSecureCheckout: "SSL VEILIG AFREKENEN",
    shippingAlert: "Voeg nog ${amount} toe voor gratis verzending!",
    vatIncluded: "Geschatte BTW (21%)",
    checkout: "Afrekenen",
    backToCart: "Terug naar Winkelwagen",
    stepShipping: "Verzending",
    stepPayment: "Betaling",
    stepReview: "Beoordeling",
    contactInfo: "Contactgegevens",
    emailAddress: "E-mailadres",
    shippingAddress: "Verzendadres",
    fullName: "Volledige Naam",
    addressLine1: "Adresregel 1",
    addressLine2: "Adresregel 2 (Optioneel)",
    city: "Stad",
    stateProvince: "Provincie",
    zipPostalCode: "Postcode",
    country: "Land",
    saveInformation: "Bewaar deze informatie voor de volgende keer",
    shippingMethod: "Verzendmethode",
    pickupFromStore: "Afhalen in de winkel",
    shippingOnDelivery: "Bezorging",
    warrantyPolicy: "Garantiebeleid",
    orderSummary: "Bestellingsoverzicht",
    continueToPayment: "Doorgaan naar Betaling",
    missingInfoTitle: "Ontbrekende Informatie",
    missingInfoText: "Vul alle verplichte velden in om door te gaan.",
    paymentCompletedTitle: "Betaling Voltooid!",
    paymentCompletedText: "Bedankt voor uw aankoop. We sturen u door naar uw ontvangstbewijs...",
    checkoutFailedTitle: "Afrekenen Mislukt",
    connectionErrorTitle: "Verbindingsfout",
    connectionErrorText: "Verbinding met de backend-server mislukt.",
    thankYou: "Bedankt!",
    orderSuccessDesc: "Uw bestelling is succesvol geplaatst en de betaling is bevestigd.",
    orderId: "Bestelnummer",
    customerName: "Naam Klant",
    totalAmount: "Totaalbedrag",
    receiptNotice: "Een PDF-ontvangstbewijs receipt_{id}.pdf is automatisch gegenereerd en gedownload naar uw downloadmap.",
    noActiveOrderTitle: "Geen Actieve Bestelling",
    noActiveOrderDesc: "We konden geen recente bestelgegevens vinden. Bezoek onze homepage om producten te kopen.",
    goToHomepage: "Ga naar Homepage",
    relatedProducts: "Gerelateerde Producten",
    returnToStore: "Terug naar de winkel",
    productNotFound: "Product Niet Gevonden",
    getInTouch: "Neem Contact Op",
    contactDesc: "We horen graag van u. Vul alstublieft het onderstaande formulier in.",
    message: "Bericht",
    sendMessage: "Bericht Verzenden",
    aboutTitle: "Over Onze Winkel",
    aboutDesc: "Wij leveren kwalitatief hoogwaardige mobiele telefoons en premium elektronische accessoires aan onze klanten wereldwijd.",
    contact: "Contact",
    information: "Informatie",
    faq: "Veelgestelde Vragen",
    privacyPolicy: "Privacybeleid",
    termsOfService: "Algemene Voorwaarden",
    newsletter: "Nieuwsbrief",
    subscribeDesc: "Meld u aan om updates, exclusieve aanbiedingen en meer te ontvangen.",
    subscribe: "Aanmelden",
    allRightsReserved: "Alle rechten voorbehouden",
    newAudioCollection: "Nieuwe Audiocollectie",
    premiumOverEarHeadphones: "PREMIUM OVER-EAR KOPTELEFOON",
    featureToday: "Vandaag Uitgelicht",
    todaySpecialPrice: "Speciale Prijs van Vandaag",
    xiaomiRedmiNote13: "XIAOMI REDMI NOTE 13 (5G)",
    shopNow: "Nu winkelen",
    smartWearables: "Smart Wearables",
    trendingSmartwatches: "POPULAIRE SMARTWATCHES",
    deliveryTitle: "GRATIS EN SNELLE BEZORGING",
    deliveryDesc: "Gratis bezorging voor alle bestellingen vanaf €140",
    customerServiceTitle: "24/7 KLANTENSERVICE",
    customerServiceDesc: "Vriendelijke 24/7 klantenservice",
    guaranteeTitle: "GELD TERUG GARANTIE",
    guaranteeDesc: "Wij retourneren geld binnen 30 dagen"
  ,
    home: "Startpagina",
    unitPrice: "Eenheidsprijs",
    qtyLabel: "Aantal",
    dateLabel: "Datum",
    paymentLabel: "Betaling",
    paidConfirmed: "BETAALD / BEVESTIGD",
    invoiceReceipt: "FACTUUR / ONTVANGSTBEWIJS",
    descriptionAndSpecs: "Beschrijving & Specificaties",
    shippingAndWarranty: "Verzending & Garantie",
    discountLabel: "Korting",
    promoDiscount: "Promo 10% Korting",
    packageLabel: "Pakket",
    packageDesc: "Verzegelde Retaildoos",
    deliveryTimeLabel: "Levertijd",
    deliveryTimeDesc: "1-2 Werkdagen",
    warrantyLabel: "Garantie",
    warrantyDesc: "6 Maanden Winkelgarantie",
    thankYouShopping: "Bedankt voor het winkelen bij Smart Telecom Store!",
    productDescription: "Productbeschrijving",
    footerQuestions: "Vragen? Bel ons 24/7!",
    usefulLinks: "Handige Links",
    featuredGallery: "Uitgelichte Galerij",
    brands: "Merken",
    categoryMobilePhone: "Mobiele Telefoon",
    categoryAccessories: "Accessoires",
    categoryGadget: "Gadget",
    categoryService: "Dienst",
    categoryParts: "Onderdelen",
    categoryComputers: "Computers",
    categoryOffers: "Aanbiedingen",
    categoryUsedPhone: "Gebruikte Telefoon",
    categoryElectronics: "Elektronica",
    newArrivalLargeTitle: "Vlaggenschip Smartphones",
    newArrivalLargeDesc: "Ervaar de ultieme prestaties en camerakwaliteit met onze nieuwste modellen.",
    newArrivalHorizontalTitle: "Premium Laptops",
    newArrivalHorizontalDesc: "Slanke, krachtige ultrabooks ontworpen voor productiviteit en creatievelingen.",
    newArrivalSquare1Title: "Draadloze Audio",
    newArrivalSquare1Desc: "High-fidelity ruisonderdrukkende audio.",
    newArrivalSquare2Title: "Slimme Wearables",
    newArrivalSquare2Desc: "Blijf actief, volg uw gezondheid en ontvang meldingen.",
    dontHaveAccount: "Nog geen account?",
    alreadyHaveAccount: "Heb je al een account?",
    createAccount: "Account Aanmaken",
    agreeTerms: "Ik ga akkoord met de algemene voorwaarden",
    rememberMe: "Onthoud mij",
    forgotPassword: "Wachtwoord Vergeten?",
    createPasswordPlaceholder: "Maak een wachtwoord aan",
    passwordPlaceholder: "Voer uw wachtwoord in",
    fullNamePlaceholder: "Voer uw volledige naam in",
    emailPlaceholder: "Voer uw e-mailadres in",
    authSubheadingLogin: "Vul uw gegevens hieronder in om toegang te krijgen",
    authSubheadingRegister: "Meld je in enkele seconden aan om te winkelen",
    validationError: "Validatiefout",
    mustAgreeTerms: "U moet akkoord gaan met de algemene voorwaarden om door te gaan.",
    creatingAccount: "Account aanmaken...",
    pleaseWaitConnect: "Wacht alstublieft terwijl we verbinding maken met de database.",
    registrationFailed: "Registratie mislukt",
    accountCreatedSuccess: "Uw account is succesvol aangemaakt. U wordt doorgestuurd naar inloggen...",
    signingIn: "Inloggen...",
    validatingCredentials: "Gegevens valideren met beveiligde server.",
    authFailed: "Authenticatie Mislukt",
    success: "Succes!",
    welcomeBack: "Welkom terug, {name}! U wordt doorgestuurd naar de startpagina...",
    authConnectionErrorText: "Kan geen verbinding maken met de authenticatieserver.",
    aboutMission: "Onze Missie",
    aboutMissionDesc: "Om mensen te verbinden met de beste technologie en reparatiediensten die het leven vereenvoudigen. We zoeken naar de hoogste kwaliteit gadgets en bieden authentieke klantenservice.",
    aboutVision: "Onze Visie",
    aboutVisionDesc: "De meest betrouwbare en premium bestemming te worden voor mobiele hardware-oplossingen en gadgets in Nederland en daarbuiten.",
    aboutGuarantee: "Onze Garantie",
    aboutGuaranteeDesc: "Wij ondersteunen onze diensten en premium artikelen met een uitgebreide garantie en topkwaliteit OEM-onderdelen voor totale gemoedsrust.",
    aboutWhoWeAre: "WIE WE ZIJN",
    aboutStoryTitle: "Premium Tech-ervaringen Creëren Sinds 2018",
    aboutStoryDesc1: "Smart Telecom Store begon als een kleine, gespecialiseerde reparatiewerkplaats die zich toelegde op het tot leven brengen van apparaten. Onze passie voor precisietechniek en diepe waardering voor premium gadgets maakten ons al snel tot een vertrouwde ankerplaats voor de gemeenschap.",
    aboutStoryDesc2: "Tegenwoordig zijn we uitgegroeid tot een uitgebreide e-commerce hub, die niet alleen deskundige reparatieoplossingen biedt, maar ook een exclusieve samengestelde collectie smartphones, audioapparaten, smart wearables en topkwaliteit accessoires.",
    aboutStatsHappy: "Tevreden Klanten",
    aboutStatsSuccess: "Reparatiesucces",
    aboutStatsSupport: "Online Ondersteuning",
    faqPillBadge: "Veelgestelde vragen",
    faqTitleFirst: "Veelgestelde",
    faqTitleSecond: "vragen",
    faqSectionDesc: "Heeft u vragen over onze diensten, het reparatieproces of productgaranties? We hebben antwoorden verzameld op de meest voorkomende vragen die onze klanten stellen.",
    faqQ1: "Welke diensten biedt Smart Telecom Store aan?",
    faqA1: "Smart Telecom Store biedt een breed scala aan premium diensten, waaronder verkoop van smartphones en tablets (nieuw en gecertificeerd tweedehands), hoogwaardige reparatiediensten (schermvervanging, batterijdiagnostiek, solderen van moederborden) und een zorgvuldig geselecteerde collectie tech-accessoires zoals hoesjes, kabels, opladers en audioapparatuur.",
    faqQ2: "Hoe lang duurt een gemiddelde mobiele reparatie?",
    faqA2: "De meeste standaard reparaties zoals schermvervangingen, batterijwissels en reparaties aan de oplaadpoort zijn binnen 30 tot 60 minuten voltooid. U kunt binnenlopen of online een afspraak maken. Geavanceerde diagnostiek of moederbordreparaties kunnen 1 tot 2 werkdagen duren.",
    faqQ3: "Biedt u garantie op reparaties en aankopen?",
    faqA3: "Absoluut! Wij bieden een zorgeloze garantie van 6 maanden op alle reparatiediensten en vervangende onderdelen. Gloednieuwe retailproducten dragen hun officiële fabrieksgarantie.",
    faqQ4: "Kan ik mijn oude apparaat inruilen bij Smart Telecom Store?",
    faqA4: "Ja, dat kan! Breng je oude telefoon of tablet naar een van onze winkels. We voeren een snelle evaluatie uit en bieden je een concurrerend winkeltegoed of contant geld dat je direct kunt gebruiken om je apparaat te upgraden."
  },
  es: {
    aboutUs: "Sobre Nosotros",
    categories: "Categorías",
    contactUs: "Contacto",
    products: "Productos",
    newArrival: "Novedades",
    searchPlaceholder: "Buscar en la tienda",
    needHelp: "¿Necesita ayuda? Llámenos:",
    signIn: "Iniciar Sesión",
    signOut: "Cerrar Sesión",
    cart: "Carrito",
    expressDelivery: "Entrega urgente en 2 a 3 días hábiles",
    callOrWhatsapp: "Llamar o WhatsApp",
    browseByCategory: "Buscar por Categoría",
    categoriesHeading: "CATEGORÍAS",
    exploreOurProducts: "Explore Nuestros Productos",
    ourProductsHeading: "NUESTROS PRODUCTOS",
    addToCart: "Añadir al Carrito",
    buyNow: "Comprar Ahora",
    noProductsFound: "No se encontraron productos",
    inStock: "En stock",
    outOfStock: "Agotado",
    reviews: "Reseñas",
    freeShipping: "Envío Gratis",
    freeShippingDesc: "Para pedidos superiores a €150 o entrega fija",
    securePayment: "Pago Seguro",
    securePaymentDesc: "Métodos de pago 100% seguros",
    helpCenter: "Centro de Ayuda 24/7",
    helpCenterDesc: "Contáctenos en cualquier momento para soporte",
    easyReturns: "Devolución Fácil",
    easyReturnsDesc: "Política de devolución sin complicaciones en 14 días",
    shoppingCart: "Carrito de Compras",
    itemsInCart: "artículos en tu carrito",
    itemInCart: "artículo en tu carrito",
    emptyCartTitle: "Tu Carrito está Vacío",
    emptyCartDesc: "Parece que aún no has añadido productos a tu carrito. Explora nuestra tienda para dispositivos y accesorios premium.",
    continueShopping: "Continuar Comprando",
    price: "Precio",
    quantity: "Cantidad",
    total: "Total",
    removeConfirmTitle: "¿Eliminar Artículo?",
    removeConfirmText: "¿Estás seguro de que deseas eliminar este artículo del carrito?",
    yesRemove: "Sí, ¡eliminar!",
    removedSuccess: "¡Eliminado!",
    removedText: "El artículo ha sido eliminado.",
    subtotal: "Subtotal",
    shipping: "Envío",
    free: "GRATIS",
    grandTotal: "Total General",
    proceedToCheckout: "Proceder al Pago",
    sslSecureCheckout: "PAGO SEGURO SSL",
    shippingAlert: "¡Añade ${amount} más para envío gratis!",
    vatIncluded: "IVA est. (21%)",
    checkout: "Pago",
    backToCart: "Volver al Carrito",
    stepShipping: "Envío",
    stepPayment: "Pago",
    stepReview: "Revisión",
    contactInfo: "Información de Contacto",
    emailAddress: "Dirección de correo electrónico",
    shippingAddress: "Dirección de Envío",
    fullName: "Nombre Completo",
    addressLine1: "Dirección Línea 1",
    addressLine2: "Dirección Línea 2 (Opcional)",
    city: "Ciudad",
    stateProvince: "Estado / Provincia",
    zipPostalCode: "Código Postal",
    country: "País",
    saveInformation: "Guardar esta información para la próxima vez",
    shippingMethod: "Método de envío",
    pickupFromStore: "Recogida en tienda",
    shippingOnDelivery: "Envío a domicilio",
    warrantyPolicy: "Política de garantía",
    orderSummary: "Resumen del Pedido",
    continueToPayment: "Continuar con el Pago",
    missingInfoTitle: "Información Faltante",
    missingInfoText: "Por favor complete todos los campos obligatorios para proceder.",
    paymentCompletedTitle: "¡Pago Completado!",
    paymentCompletedText: "Gracias por su compra. Le estamos redirigiendo a su recibo...",
    checkoutFailedTitle: "Pago Fallido",
    connectionErrorTitle: "Error de Conexión",
    connectionErrorText: "Error al conectar con el servidor backend.",
    thankYou: "¡Gracias!",
    orderSuccessDesc: "Su pedido ha sido realizado con éxito y el pago ha sido confirmado.",
    orderId: "ID del Pedido",
    customerName: "Nombre del Cliente",
    totalAmount: "Monto Total",
    receiptNotice: "Se ha generado automáticamente un recibo en PDF receipt_{id}.pdf y se ha descargado en su carpeta de descargas.",
    noActiveOrderTitle: "Sin Pedido Activo",
    noActiveOrderDesc: "No pudimos encontrar ningún detalle de transacción reciente. Visite nuestra página de inicio para comprar productos.",
    goToHomepage: "Ir a la Página de Inicio",
    relatedProducts: "Productos Relacionados",
    returnToStore: "Volver a la tienda",
    productNotFound: "Producto No Encontrado",
    getInTouch: "Póngase en Contacto",
    contactDesc: "Nos encantaría saber de usted. Por favor complete el formulario a continuación.",
    message: "Mensaje",
    sendMessage: "Enviar Mensaje",
    aboutTitle: "Sobre Nuestra Tienda",
    aboutDesc: "Ofrecemos teléfonos móviles de alta calidad y accesorios electrónicos premium a nuestros clientes en todo el mundo.",
    contact: "Contacto",
    information: "Información",
    faq: "Preguntas Frecuentes",
    privacyPolicy: "Política de Privacidad",
    termsOfService: "Términos de Servicio",
    newsletter: "Boletín Informativo",
    subscribeDesc: "Suscríbase para recibir actualizaciones, acceso a ofertas exclusivas y más.",
    subscribe: "Suscribirse",
    allRightsReserved: "Todos los derechos reservados",
    newAudioCollection: "Nueva Colección de Audio",
    premiumOverEarHeadphones: "AURICULARES PREMIUM",
    featureToday: "Destacado Hoy",
    todaySpecialPrice: "Precio Especial de Hoy",
    xiaomiRedmiNote13: "XIAOMI REDMI NOTE 13 (5G)",
    shopNow: "Comprar ahora",
    smartWearables: "Dispositivos Inteligentes",
    trendingSmartwatches: "RELOJES INTELIGENTES DE TENDENCIA",
    deliveryTitle: "ENTREGA GRATUITA Y RÁPIDA",
    deliveryDesc: "Envío gratis para pedidos superiores a €140",
    customerServiceTitle: "SERVICIO AL CLIENTE 24/7",
    customerServiceDesc: "Soporte al cliente amigable las 24 horas",
    guaranteeTitle: "GARANTÍA DE DEVOLUCIÓN DE DINERO",
    guaranteeDesc: "Devolvemos el dinero en un plazo de 30 días"
  ,
    home: "Inicio",
    unitPrice: "Precio Unitario",
    qtyLabel: "Cant.",
    dateLabel: "Fecha",
    paymentLabel: "Pago",
    paidConfirmed: "PAGADO / CONFIRMADO",
    invoiceReceipt: "FACTURA / RECIBO",
    descriptionAndSpecs: "Descripción y Especificaciones",
    shippingAndWarranty: "Envío y Garantía",
    discountLabel: "Descuento",
    promoDiscount: "Promo 10% de Descuento",
    packageLabel: "Paquete",
    packageDesc: "Caja Sellada de Fábrica",
    deliveryTimeLabel: "Plazo de Entrega",
    deliveryTimeDesc: "1-2 Días Hábiles",
    warrantyLabel: "Garantía",
    warrantyDesc: "6 Meses de Garantía de la Tienda",
    thankYouShopping: "¡Gracias por comprar en Smart Telecom Store!",
    productDescription: "Descripción del Producto",
    footerQuestions: "¿Preguntas? ¡Llámenos 24/7!",
    usefulLinks: "Enlaces Útiles",
    featuredGallery: "Galería Destacada",
    brands: "Marcas",
    categoryMobilePhone: "Teléfono Móvil",
    categoryAccessories: "Accesorios",
    categoryGadget: "Dispositivo",
    categoryService: "Servicio",
    categoryParts: "Partes",
    categoryComputers: "Computadoras",
    categoryOffers: "Ofertas",
    categoryUsedPhone: "Teléfono Usado",
    categoryElectronics: "Electrónica",
    newArrivalLargeTitle: "Teléfonos Inteligentes de Gama Alta",
    newArrivalLargeDesc: "Experimente el máximo rendimiento y la mejor calidad de cámara con nuestros últimos modelos.",
    newArrivalHorizontalTitle: "Laptops Premium",
    newArrivalHorizontalDesc: "Ultrabooks delgados y potentes diseñados para la productividad y los creadores.",
    newArrivalSquare1Title: "Audio Inalámbrico",
    newArrivalSquare1Desc: "Audio de alta fidelidad con cancelación de ruido.",
    newArrivalSquare2Title: "Dispositivos Inteligentes",
    newArrivalSquare2Desc: "Manténgase activo, controle su salud y reciba alertas.",
    dontHaveAccount: "¿No tienes una cuenta?",
    alreadyHaveAccount: "¿Ya tienes una cuenta?",
    createAccount: "Crear Cuenta",
    agreeTerms: "Acepto los Términos y Condiciones",
    rememberMe: "Recordarme",
    forgotPassword: "¿Olvidaste tu contraseña?",
    createPasswordPlaceholder: "Crea una contraseña",
    passwordPlaceholder: "Introduce tu contraseña",
    fullNamePlaceholder: "Introduce tu nombre completo",
    emailPlaceholder: "Introduce tu correo",
    authSubheadingLogin: "Introduce tus datos a continuación para acceder",
    authSubheadingRegister: "Regístrate en segundos para empezar a comprar",
    validationError: "Error de Validación",
    mustAgreeTerms: "Debe aceptar los Términos y Condiciones para continuar.",
    creatingAccount: "Creando Cuenta...",
    pleaseWaitConnect: "Espere mientras nos conectamos a la base de datos.",
    registrationFailed: "Registro Fallido",
    accountCreatedSuccess: "Tu cuenta ha sido creada con éxito. Redirigiendo al inicio de sesión...",
    signingIn: "Iniciando Sesión...",
    validatingCredentials: "Validando credenciales con el servidor seguro.",
    authFailed: "Autenticación Fallida",
    success: "¡Éxito!",
    welcomeBack: "¡Bienvenido de nuevo, {name}! Redirigiendo a la página de inicio...",
    authConnectionErrorText: "No se pudo conectar con el servidor de autenticación.",
    aboutMission: "Nuestra Misión",
    aboutMissionDesc: "Conectar a las personas con la mejor tecnología y servicios de reparación que simplifican la vida. Buscamos dispositivos de la más alta calidad y ofrecemos una atención al cliente auténtica.",
    aboutVision: "Nuestra Visión",
    aboutVisionDesc: "Convertirse en el destino más confiable y premium para soluciones de hardware móvil y dispositivos en los Países Bajos y más allá.",
    aboutGuarantee: "Nuestra Garantía",
    aboutGuaranteeDesc: "Respaldamos nuestros servicios y artículos premium con una garantía integral y piezas OEM de primer nivel para garantizar una total tranquilidad.",
    aboutWhoWeAre: "QUIÉNES SOMOS",
    aboutStoryTitle: "Creando Experiencias Tecnológicas Premium desde 2018",
    aboutStoryDesc1: "Smart Telecom Store comenzó como un pequeño taller de reparación especializado dedicado a dar vida a los dispositivos. Nuestra pasión por la ingeniería de precisión y el profundo aprecio por los dispositivos premium nos convirtieron rápidamente en un pilar de confianza para la comunidad.",
    aboutStoryDesc2: "Hoy en día, nos hemos convertido en un centro de comercio electrónico completo, que brinda no solo soluciones de reparación expertas, sino también una colección exclusiva y seleccionada de teléfonos inteligentes, dispositivos de audio, wearables inteligentes y accesorios de primer nivel.",
    aboutStatsHappy: "Clientes Felices",
    aboutStatsSuccess: "Éxito de Reparación",
    aboutStatsSupport: "Soporte en Línea",
    faqPillBadge: "Preguntas frecuentes",
    faqTitleFirst: "Preguntas",
    faqTitleSecond: "frecuentes",
    faqSectionDesc: "¿Tiene preguntas sobre nuestros servicios, el proceso de reparación o las garantías de los productos? Hemos recopilado respuestas a algunas de las preguntas más comunes que hacen nuestros clientes.",
    faqQ1: "¿Qué servicios ofrece Smart Telecom Store?",
    faqA1: "Smart Telecom Store ofrece una amplia gama de servicios premium, que incluyen la venta de teléfonos inteligentes y tabletas (nuevos y reacondicionados certificados), servicios de reparación de alta calidad (reemplazo de pantalla, diagnóstico de batería, soldadura de placa base) y una colección seleccionada de accesorios tecnológicos como fundas, cables, cargadores y equipos de audio.",
    faqQ2: "¿Cuánto tiempo suele tardar una reparación de móvil?",
    faqA2: "La mayoría de las reparaciones estándar, como reemplazos de pantalla, cambios de batería y reparaciones de puertos de carga, se completan en 30 a 60 minutos. Puede visitarnos directamente o reservar una cita en línea. Los diagnósticos avanzados o las reparaciones de placa base pueden tardar de 1 a 2 días hábiles.",
    faqQ3: "¿Ofrecen garantía en reparaciones y compras?",
    faqA3: "¡Absolutamente! Ofrecemos una garantía de 6 meses sin preocupaciones en todos los servicios de reparación y piezas de repuesto. Los productos nuevos de venta al público cuentan con las garantías oficiales de sus fabricantes.",
    faqQ4: "¿Puedo entregar mi dispositivo antiguo como parte de pago en Smart Telecom Store?",
    faqA4: "¡Sí, puedes! Trae tu teléfono o tableta antigua a cualquiera de nuestras tiendas. Realizaremos una evaluación rápida y te ofreceremos un crédito competitivo en la tienda o dinero en efectivo que podrás aplicar de inmediato para actualizar tu dispositivo."
  },
  fr: {
    aboutUs: "À Propos",
    categories: "Catégories",
    contactUs: "Contactez-nous",
    products: "Produits",
    newArrival: "Nouveautés",
    searchPlaceholder: "Rechercher dans la boutique",
    needHelp: "Besoin d'aide ? Appelez-nous :",
    signIn: "Connexion",
    signOut: "Déconnexion",
    cart: "Panier",
    expressDelivery: "Livraison express en 2 à 3 jours ouvrables",
    callOrWhatsapp: "Appeler ou WhatsApp",
    browseByCategory: "Parcourir par Catégorie",
    categoriesHeading: "CATÉGORIES",
    exploreOurProducts: "Découvrez Nos Produits",
    ourProductsHeading: "NOS PRODUITS",
    addToCart: "Ajouter au Panier",
    buyNow: "Acheter Maintenant",
    noProductsFound: "Aucun produit trouvé",
    inStock: "En stock",
    outOfStock: "Rupture de stock",
    reviews: "Avis",
    freeShipping: "Livraison Gratuite",
    freeShippingDesc: "Pour les commandes de plus de €150 ou tarif fixe",
    securePayment: "Paiement Sécurisé",
    securePaymentDesc: "Modes de paiement 100% sécurisés",
    helpCenter: "Centre d'aide 24/7",
    helpCenterDesc: "Contactez-nous à tout moment pour l'assistance",
    easyReturns: "Retour Facile",
    easyReturnsDesc: "Politique de retour sans tracas sous 14 jours",
    shoppingCart: "Panier",
    itemsInCart: "articles dans votre panier",
    itemInCart: "article dans votre panier",
    emptyCartTitle: "Votre Panier est Vide",
    emptyCartDesc: "Il semble que vous n'ayez pas encore ajouté de produits à votre panier. Explorez notre boutique pour des appareils et accessoires premium.",
    continueShopping: "Continuer mes Achats",
    price: "Prix",
    quantity: "Quantité",
    total: "Total",
    removeConfirmTitle: "Supprimer l'article ?",
    removeConfirmText: "Êtes-vous sûr de vouloir supprimer cet article du panier ?",
    yesRemove: "Oui, supprimer !",
    removedSuccess: "Supprimé !",
    removedText: "L'article a été supprimé.",
    subtotal: "Sous-total",
    shipping: "Livraison",
    free: "GRATUIT",
    grandTotal: "Total Global",
    proceedToCheckout: "Passer à la Caisse",
    sslSecureCheckout: "PAIEMENT SÉCURISÉ SSL",
    shippingAlert: "Ajoutez ${amount} de plus pour obtenir la livraison gratuite !",
    vatIncluded: "TVA estimée (21%)",
    checkout: "Passer à la Caisse",
    backToCart: "Retour au Panier",
    stepShipping: "Livraison",
    stepPayment: "Paiement",
    stepReview: "Révision",
    contactInfo: "Informations de Contact",
    emailAddress: "Adresse e-mail",
    shippingAddress: "Adresse de Livraison",
    fullName: "Nom Complet",
    addressLine1: "Adresse Ligne 1",
    addressLine2: "Adresse Ligne 2 (Optionnel)",
    city: "Ville",
    stateProvince: "État / Province",
    zipPostalCode: "Code Postal",
    country: "Pays",
    saveInformation: "Enregistrer ces informations pour la prochaine fois",
    shippingMethod: "Mode de livraison",
    pickupFromStore: "Retrait en magasin",
    shippingOnDelivery: "Livraison à domicile",
    warrantyPolicy: "Politique de garantie",
    orderSummary: "Résumé de la Commande",
    continueToPayment: "Continuer vers le Paiement",
    missingInfoTitle: "Informations Manquantes",
    missingInfoText: "Veuillez remplir tous les champs obligatoires pour continuer.",
    paymentCompletedTitle: "Paiement Terminé !",
    paymentCompletedText: "Merci pour votre achat. Nous vous redirigeons vers votre reçu...",
    checkoutFailedTitle: "Échec du Paiement",
    connectionErrorTitle: "Erreur de Connexion",
    connectionErrorText: "Impossible de se connecter au serveur backend.",
    thankYou: "Merci !",
    orderSuccessDesc: "Votre commande a été passée avec succès et le paiement est confirmé.",
    orderId: "ID de la Commande",
    customerName: "Nom du Client",
    totalAmount: "Montant Total",
    receiptNotice: "Un reçu PDF receipt_{id}.pdf a été généré automatiquement et téléchargé dans votre dossier de téléchargements.",
    noActiveOrderTitle: "Aucune Commande Active",
    noActiveOrderDesc: "Nous n'avons pas pu trouver de détails sur une transaction récente. Veuillez visiter notre page d'accueil pour acheter des produits.",
    goToHomepage: "Aller à la Page d'Accueil",
    relatedProducts: "Produits Associés",
    returnToStore: "Retourner à la boutique",
    productNotFound: "Produit Non Trouvé",
    getInTouch: "Contactez-nous",
    contactDesc: "Nous aimerions avoir de vos nouvelles. Veuillez remplir le formulaire ci-dessous.",
    message: "Message",
    sendMessage: "Envoyer le Message",
    aboutTitle: "À Propos de Notre Boutique",
    aboutDesc: "Nous fournissons des téléphones mobiles de haute qualité et des accessoires électroniques de premier choix à nos clients dans le monde entier.",
    contact: "Contact",
    information: "Information",
    faq: "FAQ",
    privacyPolicy: "Politique de Confidentialité",
    termsOfService: "Conditions d'utilisation",
    newsletter: "Newsletter",
    subscribeDesc: "Abonnez-vous pour recevoir des mises à jour, des offres exclusives et plus encore.",
    subscribe: "S'abonner",
    allRightsReserved: "Tous droits réservés",
    newAudioCollection: "Nouvelle Collection Audio",
    premiumOverEarHeadphones: "CASQUE D'ÉCOUTE HAUT DE GAMME",
    featureToday: "En Vedette Aujourd'hui",
    todaySpecialPrice: "Prix Spécial d'Aujourd'hui",
    xiaomiRedmiNote13: "XIAOMI REDMI NOTE 13 (5G)",
    shopNow: "Acheter maintenant",
    smartWearables: "Objets Connectés",
    trendingSmartwatches: "MONTRES CONNECTÉES COMPATIBLES",
    deliveryTitle: "LIVRAISON GRATUITE ET RAPIDE",
    deliveryDesc: "Livraison gratuite pour les commandes de plus de €140",
    customerServiceTitle: "SERVICE CLIENT 24/7",
    customerServiceDesc: "Service client amical disponible 24h/24",
    guaranteeTitle: "GARANTIE REMBOURSEMENT",
    guaranteeDesc: "Nous remboursons l'argent sous 30 jours"
  ,
    home: "Accueil",
    unitPrice: "Prix Unitaire",
    qtyLabel: "Qté",
    dateLabel: "Date",
    paymentLabel: "Paiement",
    paidConfirmed: "PAYÉ / CONFIRMÉ",
    invoiceReceipt: "FACTURE / REÇU",
    descriptionAndSpecs: "Description & Spécifications",
    shippingAndWarranty: "Livraison & Garantie",
    discountLabel: "Remise",
    promoDiscount: "Promo 10% de Réduction",
    packageLabel: "Emballage",
    packageDesc: "Boîte Scellée d'Origine",
    deliveryTimeLabel: "Délai de Livraison",
    deliveryTimeDesc: "1-2 Jours Ouvrables",
    warrantyLabel: "Garantie",
    warrantyDesc: "Garantie Boutique de 6 Mois",
    thankYouShopping: "Merci d'avoir fait vos achats chez Smart Telecom Store !",
    productDescription: "Description du Produit",
    footerQuestions: "Des questions ? Appelez-nous 24/7 !",
    usefulLinks: "Liens Utiles",
    featuredGallery: "Galerie en Vedette",
    brands: "Marques",
    categoryMobilePhone: "Téléphone Portable",
    categoryAccessories: "Accessoires",
    categoryGadget: "Gadget",
    categoryService: "Service",
    categoryParts: "Pièces",
    categoryComputers: "Ordinateurs",
    categoryOffers: "Offres",
    categoryUsedPhone: "Téléphone d'Occasion",
    categoryElectronics: "Électronique",
    newArrivalLargeTitle: "Smartphones Phares",
    newArrivalLargeDesc: "Découvrez des performances ultimes et une qualité photo exceptionnelle avec nos derniers modèles.",
    newArrivalHorizontalTitle: "Laptops Premium",
    newArrivalHorizontalDesc: "Des ultrabooks fins et puissants conçus pour la productivité et les créateurs.",
    newArrivalSquare1Title: "Audio Sans Fil",
    newArrivalSquare1Desc: "Audio haute fidélité à réduction de bruit.",
    newArrivalSquare2Title: "Objets Connectés",
    newArrivalSquare2Desc: "Restez actif, suivez votre santé et recevez des alertes.",
    dontHaveAccount: "Vous n'avez pas de compte ?",
    alreadyHaveAccount: "Vous avez déjà un compte ?",
    createAccount: "Créer un Compte",
    agreeTerms: "J'accepte les Conditions Générales",
    rememberMe: "Se souvenir de moi",
    forgotPassword: "Mot de passe oublié ?",
    createPasswordPlaceholder: "Créer un mot de passe",
    passwordPlaceholder: "Entrez votre mot de passe",
    fullNamePlaceholder: "Entrez votre nom complet",
    emailPlaceholder: "Entrez votre e-mail",
    authSubheadingLogin: "Entrez vos coordonnées ci-dessous pour accéder à votre compte",
    authSubheadingRegister: "Inscrivez-vous en quelques secondes pour commencer vos achats",
    validationError: "Erreur de Validation",
    mustAgreeTerms: "Vous devez accepter les Conditions Générales pour continuer.",
    creatingAccount: "Création du compte...",
    pleaseWaitConnect: "Veuillez patienter pendant la connexion à la base de données.",
    registrationFailed: "Échec de l'inscription",
    accountCreatedSuccess: "Votre compte a été créé avec succès. Redirection vers la page de connexion...",
    signingIn: "Connexion en cours...",
    validatingCredentials: "Validation des identifiants avec le serveur sécurisé.",
    authFailed: "Échec de l'authentification",
    success: "Succès !",
    welcomeBack: "Bon retour, {name} ! Redirection vers la page d'accueil...",
    authConnectionErrorText: "Impossible de se connecter au serveur d'authentification.",
    aboutMission: "Notre Mission",
    aboutMissionDesc: "Connecter les gens avec la meilleure technologie et les meilleurs services de réparation qui simplifient la vie. Nous recherchons des gadgets de la plus haute qualité et offrons un service client authentique.",
    aboutVision: "Notre Vision",
    aboutVisionDesc: "Devenir la destination la plus fiable et premium pour les solutions de matériel mobile et de gadgets aux Pays-Bas et au-delà.",
    aboutGuarantee: "Notre Garantie",
    aboutGuaranteeDesc: "Nous soutenons nos services et nos articles premium avec une garantie complète et des pièces OEM de premier ordre pour assurer une tranquillité d'esprit totale.",
    aboutWhoWeAre: "QUI SOMMES-NOUS",
    aboutStoryTitle: "Création d'expériences technologiques premium depuis 2018",
    aboutStoryDesc1: "Smart Telecom Store a commencé comme un petit atelier de réparation spécialisé dédié à redonner vie aux appareils. Notre passion pour l'ingénierie de précision et notre profonde appréciation des gadgets premium nous ont rapidement transformés en un pilier de confiance de la communauté.",
    aboutStoryDesc2: "Aujourd'hui, nous sommes devenus un centre de commerce électronique complet, offrant non seulement des solutions de réparation expertes, mais aussi une collection exclusive et sélectionnée de smartphones, d'appareils audio, de wearables intelligents et d'accessoires de premier ordre.",
    aboutStatsHappy: "Clients Heureux",
    aboutStatsSuccess: "Succès de Réparation",
    aboutStatsSupport: "Assistance en Ligne",
    faqPillBadge: "Questions fréquemment posées",
    faqTitleFirst: "Questions",
    faqTitleSecond: "fréquentes",
    faqSectionDesc: "Vous avez des questions sur nos services, notre processus de réparation ou les garanties de nos produits ? Nous avons rassemblé les réponses aux questions les plus courantes de nos clients.",
    faqQ1: "Quels services propose Smart Telecom Store ?",
    faqA1: "Smart Telecom Store propose une large gamme de services premium, notamment la vente de smartphones et de tablettes (neufs et d'occasion certifiés), des services de réparation de haute qualité (remplacement d'écran, diagnostic de batterie, soudure de carte mère) et une collection d'accessoires technologiques tels que des étuis, des câbles, des chargeurs et des équipements audio.",
    faqQ2: "Combien de temps prend généralement une réparation de mobile ?",
    faqA2: "La plupart des réparations standard telles que le remplacement d'écran, le changement de batterie et le port de charge sont terminées en 30 à 60 minutes. Vous pouvez passer directement ou réserver un rendez-vous en ligne. Les diagnostics avancés ou les réparations de carte mère peuvent prendre 1 à 2 jours ouvrables.",
    faqQ3: "Offrez-vous une garantie sur les réparations et les achats ?",
    faqA3: "Absolument ! Nous offrons une garantie sans souci de 6 mois sur tous les services de réparation et les pièces de rechange. Les produits neufs bénéficient de la garantie officielle du fabricant.",
    faqQ4: "Puis-je échanger mon ancien appareil chez Smart Telecom Store ?",
    faqA4: "Oui, vous pouvez ! Apportez votre ancien téléphone ou tablette dans l'un de nos magasins. Nous effectuerons une évaluation rapide et vous proposerons un crédit en magasin ou de l'argent liquide que vous pourrez appliquer immédiatement pour mettre à niveau votre appareil."
  },
  de: {
    aboutUs: "Über Uns",
    categories: "Kategorien",
    contactUs: "Kontakt",
    products: "Produkte",
    newArrival: "Neuheiten",
    searchPlaceholder: "Shop durchsuchen",
    needHelp: "Brauchen Sie Hilfe? Rufen Sie uns an:",
    signIn: "Einloggen",
    signOut: "Ausloggen",
    cart: "Warenkorb",
    expressDelivery: "Expressversand in 2 bis 3 Werktagen",
    callOrWhatsapp: "Anrufen oder WhatsApp",
    browseByCategory: "Nach Kategorie Durchsuchen",
    categoriesHeading: "KATEGORIEN",
    exploreOurProducts: "Entdecken Sie Unsere Produkte",
    ourProductsHeading: "UNSERE PRODUKTE",
    addToCart: "In den Warenkorb",
    buyNow: "Jetzt Kaufen",
    noProductsFound: "Keine Produkte gefunden",
    inStock: "Auf Lager",
    outOfStock: "Nicht auf Lager",
    reviews: "Bewertungen",
    freeShipping: "Kostenloser Versand",
    freeShippingDesc: "Für Bestellungen über €150 oder Pauschalversand",
    securePayment: "Sicheres Bezahlen",
    securePaymentDesc: "100% sichere Zahlungsmethoden",
    helpCenter: "24/7 Hilfezentrum",
    helpCenterDesc: "Kontaktieren Sie uns jederzeit für Kundensupport",
    easyReturns: "Einfache Rückgabe",
    easyReturnsDesc: "Problemloses Rückgaberecht innerhalb von 14 Tagen",
    shoppingCart: "Warenkorb",
    itemsInCart: "Artikel in Ihrem Warenkorb",
    itemInCart: "Artikel in Ihrem Warenkorb",
    emptyCartTitle: "Ihr Warenkorb ist leer",
    emptyCartDesc: "Es sieht so aus, als hätten Sie noch keine Produkte in Ihren Warenkorb gelegt. Erkunden Sie unseren Shop für Premium-Geräte und Zubehör.",
    continueShopping: "Weiter Einkaufen",
    price: "Preis",
    quantity: "Menge",
    total: "Gesamt",
    removeConfirmTitle: "Artikel entfernen?",
    removeConfirmText: "Sind Sie sicher, dass Sie diesen Artikel aus dem Warenkorb entfernen möchten?",
    yesRemove: "Ja, entfernen!",
    removedSuccess: "Entfernt!",
    removedText: "Artikel wurde entfernt.",
    subtotal: "Zwischensumme",
    shipping: "Versand",
    free: "KOSTENLOS",
    grandTotal: "Gesamtsumme",
    proceedToCheckout: "Zur Kasse gehen",
    sslSecureCheckout: "SSL-GESICHERTE KASSE",
    shippingAlert: "Fügen Sie noch ${amount} hinzu, um kostenlosen Versand zu erhalten!",
    vatIncluded: "Geschätzte MwSt. (21%)",
    checkout: "Kasse",
    backToCart: "Zurück zum Warenkorb",
    stepShipping: "Versand",
    stepPayment: "Zahlung",
    stepReview: "Überprüfung",
    contactInfo: "Kontaktinformationen",
    emailAddress: "E-Mail-Adresse",
    shippingAddress: "Lieferadresse",
    fullName: "Vollständiger Name",
    addressLine1: "Adresszeile 1",
    addressLine2: "Adresszeile 2 (Optional)",
    city: "Stadt",
    stateProvince: "Bundesland / Provinz",
    zipPostalCode: "Postleitzahl",
    country: "Land",
    saveInformation: "Diese Informationen für das nächste Mal speichern",
    shippingMethod: "Versandart",
    pickupFromStore: "Selbstabholung im Geschäft",
    shippingOnDelivery: "Lieferung nach Hause",
    warrantyPolicy: "Garantiebestimmungen",
    orderSummary: "Bestellübersicht",
    continueToPayment: "Weiter zur Zahlung",
    missingInfoTitle: "Fehlende Informationen",
    missingInfoText: "Bitte füllen Sie alle Pflichtfelder aus, um fortzufahren.",
    paymentCompletedTitle: "Zahlung abgeschlossen!",
    paymentCompletedText: "Vielen Dank für Ihren Einkauf. Wir leiten Sie zu Ihrem Beleg weiter...",
    checkoutFailedTitle: "Kasse fehlgeschlagen",
    connectionErrorTitle: "Verbindungsfehler",
    connectionErrorText: "Verbindung zum Backend-Server fehlgeschlagen.",
    thankYou: "Danke!",
    orderSuccessDesc: "Ihre Bestellung wurde erfolgreich aufgegeben und die Zahlung bestätigt.",
    orderId: "Bestell-ID",
    customerName: "Kundenname",
    totalAmount: "Gesamtbetrag",
    receiptNotice: "Ein PDF-Beleg receipt_{id}.pdf wurde automatisch erstellt und in Ihren Download-Ordner heruntergeladen.",
    noActiveOrderTitle: "Keine aktive Bestellung",
    noActiveOrderDesc: "Wir konnten keine aktuellen Transaktionsdetails finden. Bitte besuchen Sie unsere Homepage, um Produkte zu kaufen.",
    goToHomepage: "Zur Startseite",
    relatedProducts: "Ähnliche Produkte",
    returnToStore: "Zurück zum Shop",
    productNotFound: "Produkt nicht gefunden",
    getInTouch: "Kontaktieren Sie Uns",
    contactDesc: "Wir würden uns freuen, von Ihnen zu hören. Bitte füllen Sie das folgende Formular aus.",
    message: "Nachricht",
    sendMessage: "Nachricht senden",
    aboutTitle: "Über Unseren Shop",
    aboutDesc: "Wir bieten unseren Kunden weltweit hochwertige Mobiltelefone und erstklassiges elektronisches Zubehör.",
    contact: "Kontakt",
    information: "Informationen",
    faq: "Häufig Gestellte Fragen",
    privacyPolicy: "Datenschutzerklärung",
    termsOfService: "Nutzungsbedingungen",
    newsletter: "Newsletter",
    subscribeDesc: "Abonnieren Sie, um Updates, Zugang zu exklusiven Angeboten und mehr zu erhalten.",
    subscribe: "Abonnieren",
    allRightsReserved: "Alle Rechte vorbehalten",
    newAudioCollection: "Neue Audio-Kollektion",
    premiumOverEarHeadphones: "PREMIUM OVER-EAR KOPFHÖRER",
    featureToday: "Heute Vorgestellt",
    todaySpecialPrice: "Spezialpreis Heute",
    xiaomiRedmiNote13: "XIAOMI REDMI NOTE 13 (5G)",
    shopNow: "Jetzt kaufen",
    smartWearables: "Smart Wearables",
    trendingSmartwatches: "ANGESAGTE SMARTWATCHES",
    deliveryTitle: "KOSTENLOSER UND SCHNELLER VERSAND",
    deliveryDesc: "Kostenloser Versand für alle Bestellungen über €140",
    customerServiceTitle: "24/7 KUNDENSERVICE",
    customerServiceDesc: "Freundlicher Kundensupport rund um die Uhr",
    guaranteeTitle: "GELD-ZURÜCK-GARANTIE",
    guaranteeDesc: "Wir erstatten das Geld innerhalb von 30 Tagen"
  ,
    home: "Startseite",
    unitPrice: "Einzelpreis",
    qtyLabel: "Menge",
    dateLabel: "Datum",
    paymentLabel: "Zahlung",
    paidConfirmed: "BEZAHLT / BESTÄTIGT",
    invoiceReceipt: "RECHNUNG / BELEG",
    descriptionAndSpecs: "Beschreibung & Spezifikationen",
    shippingAndWarranty: "Versand & Garantie",
    discountLabel: "Rabatt",
    promoDiscount: "Aktion 10% Rabatt",
    packageLabel: "Paket",
    packageDesc: "Originalversiegelte Box",
    deliveryTimeLabel: "Lieferzeit",
    deliveryTimeDesc: "1-2 Werktage",
    warrantyLabel: "Garantie",
    warrantyDesc: "6 Monate Händlergarantie",
    thankYouShopping: "Vielen Dank für Ihren Einkauf bei Smart Telecom Store!",
    productDescription: "Produktbeschreibung",
    footerQuestions: "Fragen? Rufen Sie uns rund um die Uhr an!",
    usefulLinks: "Nützliche Links",
    featuredGallery: "Vorgestellte Galerie",
    brands: "Marken",
    categoryMobilePhone: "Mobiltelefon",
    categoryAccessories: "Zubehör",
    categoryGadget: "Gadget",
    categoryService: "Dienstleistung",
    categoryParts: "Teile",
    categoryComputers: "Computer",
    categoryOffers: "Angebote",
    categoryUsedPhone: "Gebrauchtes Telefon",
    categoryElectronics: "Elektronik",
    newArrivalLargeTitle: "Flaggschiff-Smartphones",
    newArrivalLargeDesc: "Erleben Sie ultimative Leistung und Kameraqualität mit unseren neuesten Modellen.",
    newArrivalHorizontalTitle: "Premium-Laptops",
    newArrivalHorizontalDesc: "Schlanke, leistungsstarke Ultrabooks für Produktivität und Kreative.",
    newArrivalSquare1Title: "Kabelloses Audio",
    newArrivalSquare1Desc: "High-Fidelity-Audio mit Rauschunterdrückung.",
    newArrivalSquare2Title: "Smart Wearables",
    newArrivalSquare2Desc: "Bleiben Sie aktiv, überwachen Sie Ihre Gesundheit und erhalten Sie Benachrichtigungen.",
    dontHaveAccount: "Haben Sie noch kein Konto?",
    alreadyHaveAccount: "Haben Sie bereits ein Konto?",
    createAccount: "Konto Erstellen",
    agreeTerms: "Ich stimme den Allgemeinen Geschäftsbedingungen zu",
    rememberMe: "Angemeldet bleiben",
    forgotPassword: "Passwort vergessen?",
    createPasswordPlaceholder: "Passwort erstellen",
    passwordPlaceholder: "Passwort eingeben",
    fullNamePlaceholder: "Vollständigen Namen eingeben",
    emailPlaceholder: "E-Mail eingeben",
    authSubheadingLogin: "Geben Sie Ihre Daten unten ein, um auf Ihr Konto zuzugreifen",
    authSubheadingRegister: "Registrieren Sie sich in Sekunden, um einzukaufen",
    validationError: "Validierungsfehler",
    mustAgreeTerms: "Sie müssen den AGB zustimmen, um fortzufahren.",
    creatingAccount: "Konto wird erstellt...",
    pleaseWaitConnect: "Bitte warten Sie, während wir eine Verbindung zur Datenbank herstellen.",
    registrationFailed: "Registrierung fehlgeschlagen",
    accountCreatedSuccess: "Ihr Konto wurde erfolgreich erstellt. Weiterleitung zum Login...",
    signingIn: "Einloggen...",
    validatingCredentials: "Anmeldedaten werden mit dem sicheren Server abgeglichen.",
    authFailed: "Authentifizierung fehlgeschlagen",
    success: "Erfolgreich!",
    welcomeBack: "Willkommen zurück, {name}! Weiterleitung zur Startseite...",
    authConnectionErrorText: "Verbindung zum Authentifizierungsserver fehlgeschlagen.",
    aboutMission: "Unsere Mission",
    aboutMissionDesc: "Menschen mit der besten Technologie und den besten Reparaturdiensten zu verbinden, die das Leben vereinfachen. Wir beziehen die hochwertigsten Gadgets und bieten eine ehrliche Kundenbetreuung.",
    aboutVision: "Unsere Vision",
    aboutVisionDesc: "Der zuverlässigste und hochwertigste Partner für mobile Hardwarelösungen und Gadgets in den Niederlanden und darüber hinaus zu werden.",
    aboutGuarantee: "Unsere Garantie",
    aboutGuaranteeDesc: "Wir unterstützen unsere Dienstleistungen und Premium-Artikel mit einer umfassenden Garantie und erstklassigen Originalersatzteilen, um Ihnen absolute Sicherheit zu geben.",
    aboutWhoWeAre: "WER WIR SIND",
    aboutStoryTitle: "Premium-Technologieerlebnisse seit 2018",
    aboutStoryDesc1: "Smart Telecom Store begann als kleine, spezialisierte Reparaturwerkstatt, die es sich zur Aufgabe gemacht hatte, Geräte wieder zum Leben zu erwecken. Unsere Leidenschaft für Präzisionstechnik und unsere tiefe Wertschätzung für Premium-Gadgets machten uns schnell zu einer vertrauenswürdigen Anlaufstelle in der Gemeinde.",
    aboutStoryDesc2: "Heute haben wir uns zu einem umfassenden E-Commerce-Hub entwickelt, der nicht nur kompetente Reparaturlösungen bietet, sondern auch eine exklusive, kuratierte Auswahl an Smartphones, Audiogeräten, Smart Wearables und erstklassigem Zubehör.",
    aboutStatsHappy: "Zufriedene Kunden",
    aboutStatsSuccess: "Reparaturerfolg",
    aboutStatsSupport: "Online-Support",
    faqPillBadge: "Häufig gestellte Fragen",
    faqTitleFirst: "Häufig gestellte",
    faqTitleSecond: "Fragen",
    faqSectionDesc: "Haben Sie Fragen zu unseren Dienstleistungen, dem Reparaturprozess oder den Produktgarantien? Wir haben Antworten auf einige der häufigsten Fragen unserer Kunden zusammengestellt.",
    faqQ1: "Welche Dienstleistungen bietet der Smart Telecom Store an?",
    faqA1: "Der Smart Telecom Store bietet eine breite Palette an Premium-Dienstleistungen, darunter den Verkauf von Smartphones und Tablets (nagelneu und zertifiziert gebraucht), hochwertige Reparaturdienste (Displaytausch, Batteriediagnose, Löten von Mainboards) und eine Auswahl an technischem Zubehör wie Hüllen, Kabel, Ladegeräte und Audiogeräte.",
    faqQ2: "Wie lange dauert eine typische Handyreparatur?",
    faqA2: "Die meisten Standardreparaturen wie Displaytausch, Batteriewechsel und die Reparatur des Ladeanschlusses sind innerhalb von 30 bis 60 Minuten abgeschlossen. Sie können direkt vorbeikommen oder online einen Termin vereinbaren. Erweiterte Diagnosen oder Mainboard-Reparaturen können 1 bis 2 Werktage dauern.",
    faqQ3: "Bieten Sie eine Garantie auf Reparaturen und Einkäufe?",
    faqA3: "Absolut! Wir bieten eine 6-monatige Sorgenfrei-Garantie auf alle Reparaturdienstleistungen und Ersatzteile. Für fabrikneue Produkte gilt die offizielle Herstellergarantie.",
    faqQ4: "Kann ich mein altes Gerät im Smart Telecom Store in Zahlung geben?",
    faqA4: "Ja, das können Sie! Bringen Sie Ihr altes Telefon oder Tablet in eine unserer Filialen. Wir führen eine schnelle Bewertung durch und bieten Ihnen ein attraktives Ladenguthaben oder Bargeld an, das Sie sofort für ein Upgrade Ihres Geräts verwenden können."
  },
  it: {
    aboutUs: "Chi Siamo",
    categories: "Categorie",
    contactUs: "Contatti",
    products: "Prodotti",
    newArrival: "Nuovi Arrivi",
    searchPlaceholder: "Cerca nel negozio",
    needHelp: "Serve aiuto? Chiamaci:",
    signIn: "Accedi",
    signOut: "Disconnetti",
    cart: "Carrello",
    expressDelivery: "Consegna espressa in 2-3 giorni lavorativi",
    callOrWhatsapp: "Chiama o WhatsApp",
    browseByCategory: "Sfoglia per Categoria",
    categoriesHeading: "CATEGORIE",
    exploreOurProducts: "Esplora i Nostri Prodotti",
    ourProductsHeading: "I NOSTRI PRODOTTI",
    addToCart: "Aggiungi al Carrello",
    buyNow: "Acquista Ora",
    noProductsFound: "Nessun prodotto trovato",
    inStock: "Disponibile",
    outOfStock: "Esaurito",
    reviews: "Recensioni",
    freeShipping: "Spedizione Gratuita",
    freeShippingDesc: "Per ordini superiori a €150 o spedizione fissa",
    securePayment: "Pagamento Sicuro",
    securePaymentDesc: "Metodi di pagamento sicuri al 100%",
    helpCenter: "Assistenza 24/7",
    helpCenterDesc: "Contattaci in qualsiasi momento per supporto",
    easyReturns: "Reso Facile",
    easyReturnsDesc: "Politica di reso senza problemi entro 14 giorni",
    shoppingCart: "Carrello della Spesa",
    itemsInCart: "articoli nel tuo carrello",
    itemInCart: "articolo nel tuo carrello",
    emptyCartTitle: "Il tuo Carrello è Vuoto",
    emptyCartDesc: "Sembra che tu non abbia ancora aggiunto prodotti al carrello. Esplora il nostro negozio per dispositivi e accessori premium.",
    continueShopping: "Continua lo Shopping",
    price: "Prezzo",
    quantity: "Quantità",
    total: "Totale",
    removeConfirmTitle: "Rimuovere l'articolo?",
    removeConfirmText: "Sei sicuro di voler rimuovere questo articolo dal carrello?",
    yesRemove: "Sí, rimuovilo!",
    removedSuccess: "Rimosso!",
    removedText: "L'articolo è stato rimosso dal carrello.",
    subtotal: "Subtotale",
    shipping: "Spedizione",
    free: "GRATIS",
    grandTotal: "Totale Complessivo",
    proceedToCheckout: "Procedi al Pagamento",
    sslSecureCheckout: "PAGAMENTO SICURO SSL",
    shippingAlert: "Aggiungi altri ${amount} per ottenere la spedizione gratuita!",
    vatIncluded: "IVA stimata (21%)",
    checkout: "Cassa",
    backToCart: "Torna al Carrello",
    stepShipping: "Spedizione",
    stepPayment: "Pagamento",
    stepReview: "Riepilogo",
    contactInfo: "Informazioni di Contatto",
    emailAddress: "Indirizzo e-mail",
    shippingAddress: "Indirizzo di Spedizione",
    fullName: "Nome Completo",
    addressLine1: "Indirizzo Linea 1",
    addressLine2: "Indirizzo Linea 2 (Opzionale)",
    city: "Città",
    stateProvince: "Stato / Provincia",
    zipPostalCode: "CAP",
    country: "Paese",
    saveInformation: "Salva queste informazioni per la prossima volta",
    shippingMethod: "Metodo di spedizione",
    pickupFromStore: "Ritiro in negozio",
    shippingOnDelivery: "Spedizione a domicilio",
    warrantyPolicy: "Politica di garanzia",
    orderSummary: "Riepilogo Ordine",
    continueToPayment: "Continua al Pagamento",
    missingInfoTitle: "Informazioni Mancanti",
    missingInfoText: "Completa tutti i campi obbligatori per procedere.",
    paymentCompletedTitle: "Pagamento Completato!",
    paymentCompletedText: "Grazie per il tuo acquisto. Ti stiamo reindirizzando alla ricevuta...",
    checkoutFailedTitle: "Pagamento Fallito",
    connectionErrorTitle: "Errore di Connessione",
    connectionErrorText: "Connessione al server backend fallita.",
    thankYou: "Grazie!",
    orderSuccessDesc: "Il tuo ordine è stato effettuato con successo e le transazioni completate.",
    orderId: "ID Ordine",
    customerName: "Nome Cliente",
    totalAmount: "Importo Totale",
    receiptNotice: "Una ricevuta in formato PDF receipt_{id}.pdf è stata generata automaticamente e scaricata nella cartella download.",
    noActiveOrderTitle: "Nessun Ordine Attivo",
    noActiveOrderDesc: "Non è stato possibile trovare i dettagli di transazioni recenti. Visita la nostra homepage per acquistare prodotti.",
    goToHomepage: "Vai alla Homepage",
    relatedProducts: "Prodotti Correlati",
    returnToStore: "Torna al negozio",
    productNotFound: "Prodotto Non Trovato",
    getInTouch: "Mettiti in Contatto",
    contactDesc: "Ci piacerebbe sentire la tua opinione. Compila il modulo sottostante.",
    message: "Messaggio",
    sendMessage: "Invia Messaggio",
    aboutTitle: "Informazioni sul Negozio",
    aboutDesc: "Forniamo telefoni cellulari di alta qualità e accessori elettronici di alta gamma ai nostri clienti in tutto il mondo.",
    contact: "Contatti",
    information: "Informazioni",
    faq: "Domande Frequenti",
    privacyPolicy: "Informativa sulla Privacy",
    termsOfService: "Termini di Servizio",
    newsletter: "Newsletter",
    subscribeDesc: "Iscriviti per ricevere aggiornamenti, accedere a offerte esclusive e altro ancora.",
    subscribe: "Iscriviti",
    allRightsReserved: "Tutti i diritti riservati",
    newAudioCollection: "Nuova Collezione Audio",
    premiumOverEarHeadphones: "CUFFIE OVER-EAR PREMIUM",
    featureToday: "In Evidenza Oggi",
    todaySpecialPrice: "Prezzo Speciale Oggi",
    xiaomiRedmiNote13: "XIAOMI REDMI NOTE 13 (5G)",
    shopNow: "Acquista ora",
    smartWearables: "Dispositivi Indossabili",
    trendingSmartwatches: "SMARTWATCH DI TENDENZA",
    deliveryTitle: "SPEDIZIONE GRATUITA E VELOCE",
    deliveryDesc: "Consegna gratuita per tutti gli ordini superiori a €140",
    customerServiceTitle: "SERVIZIO CLIENTI 24/7",
    customerServiceDesc: "Servizio clienti cordiale disponibile 24 ore su 24",
    guaranteeTitle: "GARANZIA RIMBORSO",
    guaranteeDesc: "Rimborsiamo il denaro entro 30 giorni"
  ,
    home: "Home",
    unitPrice: "Prezzo Unitario",
    qtyLabel: "Qtà",
    dateLabel: "Data",
    paymentLabel: "Pagamento",
    paidConfirmed: "PAGATO / CONFERMATO",
    invoiceReceipt: "FATTURA / RICEVUTA",
    descriptionAndSpecs: "Descrizione e Specifiche",
    shippingAndWarranty: "Spedizione e Garanzia",
    discountLabel: "Sconto",
    promoDiscount: "Promo 10% di Sconto",
    packageLabel: "Pacchetto",
    packageDesc: "Scatola Sigillata",
    deliveryTimeLabel: "Tempi di Consegna",
    deliveryTimeDesc: "1-2 Giorni Lavorativi",
    warrantyLabel: "Garanzia",
    warrantyDesc: "6 Mesi di Garanzia del Negozio",
    thankYouShopping: "Grazie per aver acquistato presso Smart Telecom Store!",
    productDescription: "Descrizione del Prodotto",
    footerQuestions: "Domande? Chiamaci 24/7!",
    usefulLinks: "Link Utili",
    featuredGallery: "Galleria in Evidenza",
    brands: "Marche",
    categoryMobilePhone: "Telefono Cellulare",
    categoryAccessories: "Accessori",
    categoryGadget: "Gadget",
    categoryService: "Servizio",
    categoryParts: "Parti",
    categoryComputers: "Computer",
    categoryOffers: "Offerte",
    categoryUsedPhone: "Telefono Usato",
    categoryElectronics: "Elettronica",
    newArrivalLargeTitle: "Smartphone Top di Gamma",
    newArrivalLargeDesc: "Scopri prestazioni eccezionali e una qualità fotografica superiore con i nostri ultimi modelli.",
    newArrivalHorizontalTitle: "Laptop Premium",
    newArrivalHorizontalDesc: "Ultrabook sottili e potenti progettati per la produttività e i creatori.",
    newArrivalSquare1Title: "Audio Wireless",
    newArrivalSquare1Desc: "Audio ad alta fedeltà con cancellazione del rumore.",
    newArrivalSquare2Title: "Dispositivi Wearable",
    newArrivalSquare2Desc: "Rimani attivo, monitora la tua salute e ricevi avvisi.",
    dontHaveAccount: "Non hai un account?",
    alreadyHaveAccount: "Hai già un account?",
    createAccount: "Crea Account",
    agreeTerms: "Accetto i Termini e le Condizioni",
    rememberMe: "Ricordami",
    forgotPassword: "Password dimenticata?",
    createPasswordPlaceholder: "Crea una password",
    passwordPlaceholder: "Inserisci la tua password",
    fullNamePlaceholder: "Inserisci il tuo nome completo",
    emailPlaceholder: "Inserisci la tua e-mail",
    authSubheadingLogin: "Inserisci i tuoi dettagli qui sotto per accedere al tuo account",
    authSubheadingRegister: "Registrati in pochi secondi per iniziare a fare acquisti",
    validationError: "Errore di Validazione",
    mustAgreeTerms: "Devi accettare i Termini e le Condizioni per procedere.",
    creatingAccount: "Creazione Account...",
    pleaseWaitConnect: "Attendere durante la connessione al database.",
    registrationFailed: "Registrazione Fallita",
    accountCreatedSuccess: "Il tuo account è stato creato con successo. Reindirizzamento al login...",
    signingIn: "Accesso in corso...",
    validatingCredentials: "Validazione delle credenziali con il server sicuro.",
    authFailed: "Autenticazione Fallita",
    success: "Successo!",
    welcomeBack: "Bentornato, {name}! Reindirizzamento alla homepage...",
    authConnectionErrorText: "Impossibile connettersi al server di autenticazione.",
    aboutMission: "La Nostra Missione",
    aboutMissionDesc: "Connettere le persone con la migliore tecnologia e servizi di riparazione che semplificano la vita. Ricerchiamo i dispositivi di più alta qualità e offriamo un servizio clienti autentico.",
    aboutVision: "La Nostra Visione",
    aboutVisionDesc: "Diventare la destinazione più affidabile e premium per soluzioni hardware mobile e gadget nei Paesi Bassi e oltre.",
    aboutGuarantee: "La Nostra Garanzia",
    aboutGuaranteeDesc: "Supportiamo i nostri servizi e articoli premium con una garanzia completa e parti OEM di prima scelta per garantire la totale tranquillità.",
    aboutWhoWeAre: "CHI SIAMO",
    aboutStoryTitle: "Creazione di esperienze tecnologiche premium dal 2018",
    aboutStoryDesc1: "Smart Telecom Store è nato come un piccolo laboratorio di riparazione specializzato dedicato a riportare in vita i dispositivi. La nostra passione per l'ingegneria di precisione e il profondo apprezzamento per i gadget premium ci hanno presto reso un punto di riferimento per la comunità.",
    aboutStoryDesc2: "Oggi siamo cresciuti fino a diventare un hub di e-commerce completo, offrendo non solo soluzioni di riparazione esperte, ma anche una collezione esclusiva e selezionata di smartphone, dispositivi audio, smart wearables e accessori di prima scelta.",
    aboutStatsHappy: "Clienti Felici",
    aboutStatsSuccess: "Successo di Riparazione",
    aboutStatsSupport: "Supporto Online",
    faqPillBadge: "Domande frequenti",
    faqTitleFirst: "Domande",
    faqTitleSecond: "frequenti",
    faqSectionDesc: "Hai domande sui nostri servizi, sul processo di riparazione o sulle garanzie dei prodotti? Abbiamo raccolto le risposte ad alcune delle domande più comuni che i nostri clienti ci pongono.",
    faqQ1: "Quali servizi offre Smart Telecom Store?",
    faqA1: "Smart Telecom Store offre una vasta gamma di servizi premium, tra cui la vendita di smartphone e tablet (nuovi e usati certificati), servizi di riparazione di alta qualità (sostituzione dello schermo, diagnostica della batteria, saldatura della scheda madre) e una collezione selezionata di accessori tecnologici come custodie, cavi, caricabatterie e apparecchiature audio.",
    faqQ2: "Quanto tempo richiede solitamente una riparazione di un telefono?",
    faqA2: "La maggior parte delle riparazioni standard, come la sostituzione dello schermo, il cambio della batteria e la riparazione della porta di ricarica, vengono completate in 30-60 minuti. Puoi passare direttamente o prenotare un appuntamento online. Diagnostiche avanzate o riparazioni della scheda madre possono richiedere 1-2 giorni lavorativi.",
    faqQ3: "Offrite una garanzia sulle riparazioni e sugli acquisti?",
    faqA3: "Assolutamente! Offriamo una garanzia di 6 mesi senza problemi su tutti i servizi di riparazione e sui pezzi di ricambio. I prodotti nuovi beneficiano della garanzia ufficiale del produttore.",
    faqQ4: "Posso permutare il mio vecchio dispositivo presso lo Smart Telecom Store?",
    faqA4: "Sì, puoi! Porta il tuo vecchio telefono o tablet in uno dei nostri negozi. Eseguiremo una rapida valutazione e ti offriremo un credito del negozio o denaro contante da poter utilizzare immediatamente per aggiornare il tuo dispositivo."
  },
  pt: {
    aboutUs: "Sobre Nós",
    categories: "Categorias",
    contactUs: "Contatos",
    products: "Produtos",
    newArrival: "Novidades",
    searchPlaceholder: "Pesquisar na loja",
    needHelp: "Precisa de ajuda? Ligue para nós:",
    signIn: "Entrar",
    signOut: "Sair",
    cart: "Carrinho",
    expressDelivery: "Entrega expressa em 2 a 3 dias úteis",
    callOrWhatsapp: "Ligar ou WhatsApp",
    browseByCategory: "Procurar por Categoria",
    categoriesHeading: "CATEGORIAS",
    exploreOurProducts: "Explore Nossos Produtos",
    ourProductsHeading: "NOSSOS PRODUTOS",
    addToCart: "Adicionar ao Carrinho",
    buyNow: "Comprar Agora",
    noProductsFound: "Nenhum produto encontrado",
    inStock: "Em estoque",
    outOfStock: "Esgotado",
    reviews: "Avaliações",
    freeShipping: "Frete Grátis",
    freeShippingDesc: "Para encomendas superiores a €150 ou entrega fixa",
    securePayment: "Pagamento Seguro",
    securePaymentDesc: "Métodos de pagamento 100% seguros",
    helpCenter: "Suporte 24/7",
    helpCenterDesc: "Contate-nos a qualquer momento para suporte ao cliente",
    easyReturns: "Devolução Fácil",
    easyReturnsDesc: "Política de devolução simplificada em até 14 dias",
    shoppingCart: "Carrinho de Compras",
    itemsInCart: "itens no seu carrinho",
    itemInCart: "item no seu carrinho",
    emptyCartTitle: "Seu Carrinho está Vazio",
    emptyCartDesc: "Parece que você ainda não adicionou produtos ao seu carrinho. Explore a nossa loja para dispositivos e acessórios premium.",
    continueShopping: "Continuar Comprando",
    price: "Preço",
    quantity: "Quantidade",
    total: "Total",
    removeConfirmTitle: "Remover Item?",
    removeConfirmText: "Tem certeza de que deseja remover este item do carrinho?",
    yesRemove: "Sim, remover!",
    removedSuccess: "Removido!",
    removedText: "O item foi removido.",
    subtotal: "Subtotal",
    shipping: "Frete",
    free: "GRÁTIS",
    grandTotal: "Total Geral",
    proceedToCheckout: "Prosseguir para o Pagamento",
    sslSecureCheckout: "PAGAMENTO SEGURO SSL",
    shippingAlert: "Adicione mais ${amount} para ganhar frete grátis!",
    vatIncluded: "IVA est. (21%)",
    checkout: "Finalizar Compra",
    backToCart: "Voltar ao Carrinho",
    stepShipping: "Envio",
    stepPayment: "Pagamento",
    stepReview: "Revisão",
    contactInfo: "Informações de Contato",
    emailAddress: "Endereço de e-mail",
    shippingAddress: "Endereço de Envio",
    fullName: "Nome Completo",
    addressLine1: "Endereço Linha 1",
    addressLine2: "Endereço Linha 2 (Opcional)",
    city: "Cidade",
    stateProvince: "Estado / Província",
    zipPostalCode: "Código Postal / CEP",
    country: "País",
    saveInformation: "Salvar estas informações para a próxima vez",
    shippingMethod: "Método de envio",
    pickupFromStore: "Retirada na loja",
    shippingOnDelivery: "Entrega em domicílio",
    warrantyPolicy: "Política de garantia",
    orderSummary: "Resumo do Pedido",
    continueToPayment: "Continuar para o Pagamento",
    missingInfoTitle: "Informações Faltando",
    missingInfoText: "Por favor, preencha todos os campos obrigatórios para prosseguir.",
    paymentCompletedTitle: "Pagamento Concluído!",
    paymentCompletedText: "Obrigado por sua compra. Estamos redirecionando para o seu recibo...",
    checkoutFailedTitle: "Falha na Compra",
    connectionErrorTitle: "Erro de Conexão",
    connectionErrorText: "Falha ao conectar com o servidor backend.",
    thankYou: "Obrigado!",
    orderSuccessDesc: "Seu pedido foi realizado com sucesso e o pagamento está confirmado.",
    orderId: "ID do Pedido",
    customerName: "Nome do Cliente",
    totalAmount: "Valor Total",
    receiptNotice: "Um recibo em PDF receipt_{id}.pdf foi gerado automaticamente e baixado para sua pasta de downloads.",
    noActiveOrderTitle: "Nenhum Pedido Ativo",
    noActiveOrderDesc: "Não conseguimos encontrar detalhes de transações recentes. Visite nossa página inicial para comprar produtos.",
    goToHomepage: "Ir para a Página Inicial",
    relatedProducts: "Produtos Relacionados",
    returnToStore: "Voltar para a loja",
    productNotFound: "Produto Não Encontrado",
    getInTouch: "Entre em Contato",
    contactDesc: "Gostaríamos muito de ouvir você. Por favor, preencha o formulário abaixo.",
    message: "Message",
    sendMessage: "Enviar Mensagem",
    aboutTitle: "Sobre a Nossa Loja",
    aboutDesc: "Fornecemos celulares de alta qualidade e acessórios eletrônicos premium para nossos clientes em todo o mundo.",
    contact: "Contato",
    information: "Informação",
    faq: "Perguntas Frequentes",
    privacyPolicy: "Política de Privacidade",
    termsOfService: "Terms of Service",
    newsletter: "Newsletter",
    subscribeDesc: "Inscreva-se para receber atualizações, acesso a ofertas exclusivas e muito mais.",
    subscribe: "Inscrever-se",
    allRightsReserved: "Todos os direitos reservados",
    newAudioCollection: "Nova Coleção de Áudio",
    premiumOverEarHeadphones: "AUSCULTADORES PREMIUM OVER-EAR",
    featureToday: "Destaque de Hoje",
    todaySpecialPrice: "Preço Especial de Hoje",
    xiaomiRedmiNote13: "XIAOMI REDMI NOTE 13 (5G)",
    shopNow: "Comprar agora",
    smartWearables: "Dispositivos Inteligentes",
    trendingSmartwatches: "SMARTWATCHES DE TENDÊNCIA",
    deliveryTitle: "ENTREGA RÁPIDA E GRATUITA",
    deliveryDesc: "Frete grátis para todos os pedidos acima de €140",
    customerServiceTitle: "SUPORTE AO CLIENTE 24/7",
    customerServiceDesc: "Suporte ao cliente amigável 24 horas por dia",
    guaranteeTitle: "GARANTIA DE REEMBOLSO",
    guaranteeDesc: "Nós devolvemos o dinheiro dentro de 30 dias"
  ,
    home: "Início",
    unitPrice: "Preço Unitário",
    qtyLabel: "Qtd.",
    dateLabel: "Data",
    paymentLabel: "Pagamento",
    paidConfirmed: "PAGO / CONFIRMADO",
    invoiceReceipt: "FATURA / RECIBO",
    descriptionAndSpecs: "Descrição e Especificações",
    shippingAndWarranty: "Envio e Garantia",
    discountLabel: "Desconto",
    promoDiscount: "Promo 10% de Desconto",
    packageLabel: "Pacote",
    packageDesc: "Caixa Selada de Fábrica",
    deliveryTimeLabel: "Prazo de Entrega",
    deliveryTimeDesc: "1-2 Dias Úteis",
    warrantyLabel: "Garantia",
    warrantyDesc: "6 Meses de Garantia da Loja",
    thankYouShopping: "Obrigado por comprar na Smart Telecom Store!",
    productDescription: "Descrição do Produto",
    footerQuestions: "Dúvidas? Ligue para nós 24/7!",
    usefulLinks: "Links Úteis",
    featuredGallery: "Galeria em Destaque",
    brands: "Marcas",
    categoryMobilePhone: "Telemóvel",
    categoryAccessories: "Acessórios",
    categoryGadget: "Gadget",
    categoryService: "Serviço",
    categoryParts: "Peças",
    categoryComputers: "Computadores",
    categoryOffers: "Ofertas",
    categoryUsedPhone: "Telemóvel Usado",
    categoryElectronics: "Eletrónicos",
    newArrivalLargeTitle: "Smartphones Top de Linha",
    newArrivalLargeDesc: "Experimente o máximo desempenho e qualidade de câmera com nossos modelos mais recentes.",
    newArrivalHorizontalTitle: "Laptops Premium",
    newArrivalHorizontalDesc: "Ultrabooks finos e potentes projetados para produtividade e criadores.",
    newArrivalSquare1Title: "Áudio Sem Fio",
    newArrivalSquare1Desc: "Áudio de alta eficiência com cancelamento de ruído.",
    newArrivalSquare2Title: "Smart Wearables",
    newArrivalSquare2Desc: "Mantenha-se ativo, monitore sua saúde e receba alertas.",
    dontHaveAccount: "Não tem uma conta?",
    alreadyHaveAccount: "Já tem uma conta?",
    createAccount: "Criar Conta",
    agreeTerms: "Concordo com os Termos e Condições",
    rememberMe: "Lembrar de mim",
    forgotPassword: "Esqueceu a senha?",
    createPasswordPlaceholder: "Crie uma senha",
    passwordPlaceholder: "Digite sua senha",
    fullNamePlaceholder: "Digite seu nome completo",
    emailPlaceholder: "Digite seu e-mail",
    authSubheadingLogin: "Insira seus dados abaixo para acessar sua conta",
    authSubheadingRegister: "Cadastre-se em segundos para começar a comprar",
    validationError: "Erro de Validação",
    mustAgreeTerms: "Você deve concordar com os Termos e Condições para prosseguir.",
    creatingAccount: "Criando Conta...",
    pleaseWaitConnect: "Por favor, aguarde enquanto nos conectamos ao banco de dados.",
    registrationFailed: "Falha no Registro",
    accountCreatedSuccess: "Sua conta foi criada com sucesso. Redirecionando para o login...",
    signingIn: "Entrando...",
    validatingCredentials: "Validando credenciais com o servidor seguro.",
    authFailed: "Falha na Autenticação",
    success: "Sucesso!",
    welcomeBack: "Bem-vindo de volta, {name}! Redirecionando para a página inicial...",
    authConnectionErrorText: "Não foi possível conectar ao servidor de autenticação.",
    aboutMission: "Nossa Missão",
    aboutMissionDesc: "Conectar as pessoas com a melhor tecnologia e serviços de reparo que simplificam a vida. Buscamos os dispositivos de mais alta qualidade e oferecemos um atendimento ao cliente autêntico.",
    aboutVision: "Nossa Visão",
    aboutVisionDesc: "Tornar-se o destino mais confiável e premium para soluções de hardware móvel e gadgets na Holanda e além.",
    aboutGuarantee: "Nossa Garantia",
    aboutGuaranteeDesc: "Apoiamos nossos serviços e itens premium com uma garantia abrangente e peças OEM de primeira linha para garantir total tranquilidade.",
    aboutWhoWeAre: "QUEM SOMOS",
    aboutStoryTitle: "Criando Experiências Tecnológicas Premium desde 2018",
    aboutStoryDesc1: "A Smart Telecom Store começou como uma pequena oficina de reparo especializada dedicada a trazer os dispositivos de volta à vida. Nossa paixão pela engenharia de precisão e profundo apreço por gadgets premium rapidamente nos transformaram em uma referência de segurança na comunidade.",
    aboutStoryDesc2: "Hoje, crescemos e nos tornamos um hub de comércio eletrônico abrangente, fornecendo não apenas soluções de reparo especializadas, mas também uma coleção exclusiva e selecionada de smartphones, dispositivos de áudio, wearables inteligentes e acessórios de primeira linha.",
    aboutStatsHappy: "Clientes Felizes",
    aboutStatsSuccess: "Sucesso no Reparo",
    aboutStatsSupport: "Suporte Online",
    faqPillBadge: "Perguntas frequentes",
    faqTitleFirst: "Perguntas",
    faqTitleSecond: "frequentes",
    faqSectionDesc: "Tem dúvidas sobre nossos serviços, processo de reparo ou garantias de produtos? Reunimos as respostas para algumas das perguntas mais comuns que nossos clientes fazem.",
    faqQ1: "Quais serviços a Smart Telecom Store oferece?",
    faqA1: "A Smart Telecom Store oferece uma ampla gama de serviços premium, incluindo vendas de smartphones e tablets (novos e usados certificados), serviços de reparo de alta qualidade (substituição de tela, diagnóstico de bateria, solda de placa-mãe) e uma coleção selecionada de acessórios tecnológicos, como capas, cabos, carregadores e equipamentos de áudio.",
    faqQ2: "Quanto tempo costuma demorar um reparo de telemóvel?",
    faqA2: "A maioria dos reparos padrão, como substituição de tela, troca de bateria e reparos de porta de carregamento, é concluída em 30 a 60 minutos. Você pode vir diretamente ou agendar um horário online. Diagnósticos avançados ou reparos de placa-mãe podem levar de 1 a 2 dias úteis.",
    faqQ3: "Vocês oferecem garantia nos reparos e compras?",
    faqA3: "Com certeza! Oferecemos uma garantia sem preocupações de 6 meses em todos os serviços de reparo e peças de reposição. Os produtos novos de varejo possuem as garantias oficiais dos seus fabricantes.",
    faqQ4: "Posso trocar meu aparelho antigo na Smart Telecom Store?",
    faqA4: "Sim, você pode! Traga seu celular ou tablet antigo a qualquer uma de nossas lojas. Realizaremos uma avaliação rápida e ofereceremos um crédito competitivo na loja ou dinheiro que você poderá aplicar imediatamente para atualizar seu dispositivo."
  },
  el: {
    aboutUs: "Σχετικά με Εμάς",
    categories: "Κατηγορίες",
    contactUs: "Επικοινωνία",
    products: "Προϊόντα",
    newArrival: "Νέες Αφίξεις",
    searchPlaceholder: "Αναζήτηση στο κατάστημα",
    needHelp: "Χρειάζεστε βοήθεια; Καλέστε μας:",
    signIn: "Σύνδεση",
    signOut: "Αποσύνδεση",
    cart: "Καλάθι",
    expressDelivery: "Express Παράδοση σε 2 έως 3 Εργάσιμες Ημέρες",
    callOrWhatsapp: "Κλήση ή WhatsApp",
    browseByCategory: "Αναζήτηση ανά Κατηγορία",
    categoriesHeading: "ΚΑΤΗΓΟΡΙΕΣ",
    exploreOurProducts: "Ανακαλύψτε τα Προϊόντα μας",
    ourProductsHeading: "ΤΑ ΠΡΟΪΟΝΤΑ ΜΑΣ",
    addToCart: "Προσθήκη στο Καλάθι",
    buyNow: "Αγορά Τώρα",
    noProductsFound: "Δεν βρέθηκαν προϊόντα",
    inStock: "Σε απόθεμα",
    outOfStock: "Εξαντλήθηκε",
    reviews: "Αξιολογήσεις",
    freeShipping: "Δωρεάν Μεταφορικά",
    freeShippingDesc: "Για παραγγελίες άνω των €150 ή σταθερή χρέωση",
    securePayment: "Ασφαλείς Πληρωμές",
    securePaymentDesc: "100% ασφαλείς μέθοδοι πληρωμής",
    helpCenter: "24/7 Κέντρο Υποστήριξης",
    helpCenterDesc: "Επικοινωνήστε μαζί μας ανά πάσα στιγμή για υποστήριξη",
    easyReturns: "Εύκολες Επιστροφές",
    easyReturnsDesc: "Πολιτική επιστροφών χωρίς προβλήματα εντός 14 ημερών",
    shoppingCart: "Καλάθι Αγορών",
    itemsInCart: "προϊόντα στο καλάθι σας",
    itemInCart: "προϊόν στο καλάθι σας",
    emptyCartTitle: "Το Καλάθι σας είναι Άδειο",
    emptyCartDesc: "Φαίνεται ότι δεν έχετε προσθέσει ακόμα προϊόντα στο καλάθι σας. Εξερευνήστε το κατάστημά μας για κορυφαίες συσκευές και αξεσουάρ.",
    continueShopping: "Συνέχεια Αγορών",
    price: "Τιμή",
    quantity: "Ποσότητα",
    total: "Σύνολο",
    removeConfirmTitle: "Αφαίρεση Προϊόντος;",
    removeConfirmText: "Είστε σίγουροι ότι θέλετε να αφαιρέσετε αυτό το προϊόν από το καλάθι;",
    yesRemove: "Ναι, αφαιρέστε το!",
    removedSuccess: "Αφαιρέθηκε!",
    removedText: "Το προϊόν αφαιρέθηκε από το καλάθι.",
    subtotal: "Υποσύνολο",
    shipping: "Μεταφορικά",
    free: "ΔΩΡΕΑΝ",
    grandTotal: "Γενικό Σύνολο",
    proceedToCheckout: "Προχωρήστε στο Ταμείο",
    sslSecureCheckout: "SSL ΑΣΦΑΛΗΣ ΟΛΟΚΛΗΡΩΣΗ ΑΓΟΡΑΣ",
    shippingAlert: "Προσθέστε ακόμα ${amount} για δωρεάν μεταφορικά!",
    vatIncluded: "Εκτιμώμενος ΦΠΑ (21%)",
    checkout: "Ταμείο",
    backToCart: "Επιστροφή στο Καλάθι",
    stepShipping: "Αποστολή",
    stepPayment: "Πληρωμή",
    stepReview: "Ανασκόπηση",
    contactInfo: "Στοιχεία Επικοινωνίας",
    emailAddress: "Διεύθυνση Email",
    shippingAddress: "Διεύθυνση Αποστολής",
    fullName: "Ονοματεπώνυμο",
    addressLine1: "Διεύθυνση 1",
    addressLine2: "Διεύθυνση 2 (Προαιρετικό)",
    city: "Πόλη",
    stateProvince: "Περιοχή / Επαρχία",
    zipPostalCode: "Ταχυδρομικός Κώδικας",
    country: "Χώρα",
    saveInformation: "Αποθήκευση αυτών των στοιχείων για την επόμενη φορά",
    shippingMethod: "Μέθοδος Αποστολής",
    pickupFromStore: "Παραλαβή από το κατάστημα",
    shippingOnDelivery: "Αποστολή με παράδοση",
    warrantyPolicy: "Πολιτική Εγγύησης",
    orderSummary: "Σύνοψη Παραγγελίας",
    continueToPayment: "Συνέχεια στην Πληρωμή",
    missingInfoTitle: "Λείπουν Στοιχεία",
    missingInfoText: "Παρακαλούμε συμπληρώστε όλα τα απαιτούμενα πεδία για να προχωρήσετε.",
    paymentCompletedTitle: "Η Πληρωμή Ολοκληρώθηκε!",
    paymentCompletedText: "Σας ευχαριστούμε για την αγορά σας. Σας μεταφέρουμε στην απόδειξη...",
    checkoutFailedTitle: "Αποτυχία Ολοκλήρωσης Αγοράς",
    connectionErrorTitle: "Σφάλμα Σύνδεσης",
    connectionErrorText: "Αποτυχία σύνδεσης με τον διακομιστή backend.",
    thankYou: "Ευχαριστούμε!",
    orderSuccessDesc: "Η παραγγελία σας καταχωρήθηκε επιτυχώς και η πληρωμή επιβεβαιώθηκε.",
    orderId: "ID Παραγγελίας",
    customerName: "Όνομα Πελάτη",
    totalAmount: "Συνολικό Ποσό",
    receiptNotice: "Η απόδειξη PDF με όνομα receipt_{id}.pdf δημιουργήθηκε αυτόματα και αποθηκεύτηκε στο φάκελο λήψεων.",
    noActiveOrderTitle: "Καμία Ενεργή Παραγγελία",
    noActiveOrderDesc: "Δεν μπορέσαμε να βρούμε πρόσφατα στοιχεία παραγγελίας. Παρακαλούμε επισκεφθείτε την αρχική μας σελίδα για να αγοράσετε προϊόντα.",
    goToHomepage: "Μετάβαση στην Αρχική",
    relatedProducts: "Σχετικά Προϊόντα",
    returnToStore: "Επιστροφή στο Κατάστημα",
    productNotFound: "Το Προϊόν δεν Βρέθηκε",
    getInTouch: "Επικοινωνήστε Μαζί Μας",
    contactDesc: "Θα θέλαμε πολύ να σας ακούσουμε. Παρακαλούμε συμπληρώστε την παρακάτω φόρμα.",
    message: "Μήνυμα",
    sendMessage: "Αποστολή Μηνύματος",
    aboutTitle: "Σχετικά με το Κατάστημά μας",
    aboutDesc: "Παρέχουμε υψηλής ποιότητας κινητά τηλέφωνα και premium ηλεκτρονικά αξεσουάρ στους πελάτες μας σε όλο τον κόσμο.",
    contact: "Επικοινωνία",
    information: "Πληροφορίες",
    faq: "Συχνές Ερωτήσεις",
    privacyPolicy: "Πολιτική Απορρήτου",
    termsOfService: "Όροι Χρήσης",
    newsletter: "Newsletter",
    subscribeDesc: "Εγγραφείτε για να λαμβάνετε ενημερώσεις, πρόσβαση σε αποκλειστικές προσφορές και πολλά άλλα.",
    subscribe: "Εγγραφή",
    allRightsReserved: "Με την επιφύλαξη παντός δικαιώματος",
    newAudioCollection: "Νέα Συλλογή Ήχου",
    premiumOverEarHeadphones: "PREMIUM OVER-EAR ΑΚΟΥΣΤΙΚΑ",
    featureToday: "Προτεινόμενο Σήμερα",
    todaySpecialPrice: "Ειδική Τιμή Σήμερα",
    xiaomiRedmiNote13: "XIAOMI REDMI NOTE 13 (5G)",
    shopNow: "Αγορά τώρα",
    smartWearables: "Έξυπνα Ρολόγια & Bands",
    trendingSmartwatches: "ΔΗΜΟΦΙΛΗ SMARTWATCHES",
    deliveryTitle: "ΔΩΡΕΑΝ ΚΑΙ ΓΡΗΓΟΡΗ ΠΑΡΑΔΟΣΗ",
    deliveryDesc: "Δωρεάν παράδοση για όλες τις παραγγελίες άνω των €140",
    customerServiceTitle: "24/7 ΕΞΥΠΗΡΕΤΗΣΗ ΠΕΛΑΤΩΝ",
    customerServiceDesc: "Φιλική υποστήριξη πελατών όλο το 24ωρο",
    guaranteeTitle: "ΕΓΓΥΗΣΗ ΕΠΙΣΤΡΟΦΗΣ ΧΡΗΜΑΤΩΝ",
    guaranteeDesc: "Επιστρέφουμε χρήματα εντός 30 ημερών"
  ,
    home: "Αρχική",
    unitPrice: "Τιμή Μονάδας",
    qtyLabel: "Ποσ.",
    dateLabel: "Ημερομηνία",
    paymentLabel: "Πληρωμή",
    paidConfirmed: "ΠΛΗΡΩΘΗΚΕ / ΕΠΙΒΕΒΑΙΩΘΗΚΕ",
    invoiceReceipt: "ΤΙΜΟΛΟΓΙΟ / ΑΠΟΔΕΙΞΗ",
    descriptionAndSpecs: "Περιγραφή & Προδιαγραφές",
    shippingAndWarranty: "Αποστολή & Εγγύηση",
    discountLabel: "Έκπτωση",
    promoDiscount: "Προσφορά 10% Έκπτωση",
    packageLabel: "Συσκευασία",
    packageDesc: "Σφραγισμένο Κουτί Λιανικής",
    deliveryTimeLabel: "Χρόνος Παράδοσης",
    deliveryTimeDesc: "1-2 Εργάσιμες Ημέρες",
    warrantyLabel: "Εγγύηση",
    warrantyDesc: "6 Μήνες Εγγύηση Καταστήματος",
    thankYouShopping: "Σας ευχαριστούμε που επιλέξατε το Smart Telecom Store!",
    productDescription: "Περιγραφή Προϊόντος",
    footerQuestions: "Έχετε Ερωτήσεις; Καλέστε μας 24/7!",
    usefulLinks: "Χρήσιμοι Σύνδεσμοι",
    featuredGallery: "Προτεινόμενη Γκαλερί",
    brands: "Μάρκες",
    categoryMobilePhone: "Κινητό Τηλέφωνο",
    categoryAccessories: "Αξεσουάρ",
    categoryGadget: "Γκάτζετ",
    categoryService: "Υπηρεσία",
    categoryParts: "Ανταλλακτικά",
    categoryComputers: "Υπολογιστές",
    categoryOffers: "Προσφορές",
    categoryUsedPhone: "Μεταχειρισμένο Τηλέφωνο",
    categoryElectronics: "Ηλεκτρονικά",
    newArrivalLargeTitle: "Κορυφαία Smartphone",
    newArrivalLargeDesc: "Απολαύστε κορυφαία απόδοση και ποιότητα κάμερας με τα τελευταία μας μοντέλα.",
    newArrivalHorizontalTitle: "Premium Laptops",
    newArrivalHorizontalDesc: "Λεπτά και ισχυρά ultrabooks σχεδιασμένα για παραγωγικότητα και δημιουργούς.",
    newArrivalSquare1Title: "Ασύρματος Ήχος",
    newArrivalSquare1Desc: "Ήχος υψηλής πιστότητας με ακύρωση θορύβου.",
    newArrivalSquare2Title: "Smart Wearables",
    newArrivalSquare2Desc: "Μείνετε δραστήριοι, παρακολουθήστε την υγεία σας και λάβετε ειδοποιήσεις.",
    dontHaveAccount: "Δεν έχετε λογαριασμό;",
    alreadyHaveAccount: "Έχετε ήδη λογαριασμό;",
    createAccount: "Δημιουργία Λογαριασμού",
    agreeTerms: "Συμφωνώ με τους Όρους & Προϋποθέσεις",
    rememberMe: "Να με θυμάσαι",
    forgotPassword: "Ξέχασες τον Κωδικό σου;",
    createPasswordPlaceholder: "Δημιουργήστε έναν κωδικό",
    passwordPlaceholder: "Εισάγετε τον κωδικό σας",
    fullNamePlaceholder: "Εισάγετε το ονοματεπώνυμό σας",
    emailPlaceholder: "Εισάγετε το email σας",
    authSubheadingLogin: "Εισάγετε τα στοιχεία σας παρακάτω για πρόσβαση",
    authSubheadingRegister: "Εγγραφείτε σε δευτερόλεπτα για να ξεκινήσετε τις αγορές σας",
    validationError: "Σφάλμα Επικύρωσης",
    mustAgreeTerms: "Πρέπει να συμφωνήσετε με τους Όρους & Προϋποθέσεις για να προχωρήσετε.",
    creatingAccount: "Δημιουργία Λογαριασμού...",
    pleaseWaitConnect: "Παρακαλώ περιμένετε μέχρι να συνδεθούμε στη βάση δεδομένων.",
    registrationFailed: "Η Εγγραφή Απέτυχε",
    accountCreatedSuccess: "Ο λογαριασμός σας δημιουργήθηκε επιτυχώς. Μεταφορά στη σύνδεση...",
    signingIn: "Σύνδεση σε εξέλιξη...",
    validatingCredentials: "Επαλήθευση στοιχείων με ασφαλή διακομιστή.",
    authFailed: "Η Ταυτοποίηση Απέτυχε",
    success: "Επιτυχία!",
    welcomeBack: "Καλώς ορίσατε ξανά, {name}! Μεταφορά στην αρχική σελίδα...",
    authConnectionErrorText: "Δεν ήταν δυνατή η σύνδεση με τον διακομιστή ταυτοποίησης.",
    aboutMission: "Η Αποστολή μας",
    aboutMissionDesc: "Να συνδέουμε τους ανθρώπους με την καλύτερη τεχνολογία και υπηρεσίες επισκευής που απλοποιούν τη ζωή. Αναζητούμε τα πιο ποιοτικά gadget και παρέχουμε αυθεντική φροντίδα πελατών.",
    aboutVision: "Το Όραμά μας",
    aboutVisionDesc: "Να γίνουμε ο πιο αξιόπιστος και premium προορισμός για λύσεις κινητού υλικού και gadget στην Ολλανδία και πέρα από αυτήν.",
    aboutGuarantee: "Η Εγγύησή μας",
    aboutGuaranteeDesc: "Υποστηρίζουμε τις υπηρεσίες και τα premium προϊόντα μας με ολοκληρωμένη εγγύηση και κορυφαία ανταλλακτικά OEM για να διασφαλίσουμε απόλυτη ηρεμία.",
    aboutWhoWeAre: "ΠΟΙΟΙ ΕΙΜΑΣΤΕ",
    aboutStoryTitle: "Δημιουργία Premium Εμπειριών Τεχνολογίας Από το 2018",
    aboutStoryDesc1: "Το Smart Telecom Store ξεκίνησε ως ένα μικρό, εξειδικευμένο εργαστήριο επισκευών αφιερωμένο στην επαναφορά συσκευών στη ζωή. Το πάθος μας για μηχανική ακριβείας και η βαθιά εκτίμηση για premium gadget μας μετέτρεψαν γρήγορα σε ένα αξιόπιστο στήριγμα της κοινότητας.",
    aboutStoryDesc2: "Σήμερα, έχουμε εξελιχθεί σε έναν ολοκληρωμένο κόμβο ηλεκτρονικού εμπορίου, παρέχοντας όχι μόνο εξειδικευμένες λύσεις επισκευής αλλά και μια αποκλειστική επιμελημένη συλλογή smartphone, συσκευών ήχου, έξυπνων φορετών συσκευών και αξεσουάρ κορυφαίας κατηγορίας.",
    aboutStatsHappy: "Ευχαριστημένοι Πελάτες",
    aboutStatsSuccess: "Επιτυχία Επισκευών",
    aboutStatsSupport: "Online Υποστήριξη",
    faqPillBadge: "Συχνές ερωτήσεις",
    faqTitleFirst: "Συχνές",
    faqTitleSecond: "ερωτήσεις",
    faqSectionDesc: "Έχετε ερωτήσεις σχετικά με τις υπηρεσίες μας, τη διαδικασία επισκευής ή τις εγγυήσεις των προϊόντων; Συγκεντρώσαμε απαντήσεις σε μερικές από τις πιο συνηθισμένες ερωτήσεις που κάνουν οι πελάτες μας.",
    faqQ1: "Ποιες υπηρεσίες προσφέρει το Smart Telecom Store;",
    faqA1: "Το Smart Telecom Store προσφέρει ένα ευρύ φάσμα premium υπηρεσιών, συμπεριλαμβανομένων πωλήσεων smartphone και tablet (ολοκαίνουργια και πιστοποιημένα μεταχειρισμένα), υπηρεσιών επισκευής υψηλής ποιότητας (αντικατάσταση οθόνης, διάγνωση μπαταρίας, συγκόλληση μητρικής πλακέτας) και μια επιμελημένη συλλογή τεχνολογικών αξεσουάρ όπως θήκες, καλώδια, φορτιστές και εξοπλισμό ήχου.",
    faqQ2: "Πόσος χρόνος χρειάζεται συνήθως για μια επισκευή κινητού;",
    faqA2: "Οι περισσότερες τυπικές επισκευές όπως αντικαταστάσεις οθόνης, αλλαγές μπαταριών και επισκευές θύρας φόρτισης ολοκληρώνονται σε 30 έως 60 λεπτά. Υπορείτε να έρθετε απευθείας ή να κλείσετε ραντεβού online. Οι προηγμένες διαγνώσεις ή οι επισκευές μητρικής πλακέτας ενδέχεται να χρειαστούν 1 έως 2 εργάσιμες ημέρες.",
    faqQ3: "Προσφέρετε εγγύηση για επισκευές και αγορές;",
    faqA3: "Απολύτως! Προσφέρουμε μια ξέγνοιαστη εγγύηση 6 μηνών σε όλες τις υπηρεσίες επισκευής και τα ανταλλακτικά. Τα ολοκαίνουργια προϊόντα λιανικής φέρουν τις επίσημες εγγυήσεις των κατασκευαστών τους.",
    faqQ4: "Μπορώ να ανταλλάξω την παλιά μου συσκευή στο Smart Telecom Store;",
    faqA4: "Yes, you can! Φέρτε την παλιά σας συσκευή στο κατάστημα. Θα πραγματοποιήσουμε μια γρήγορη αξιολόγηση και θα σας προσφέρουμε ανταγωνιστική έκπτωση ή μετρητά."
  }
};
